<template>
  <div ref="goodDetail" class="goodDetails">
    <Menu />
    <draggable-resizable v-if="draggableVisible && detail.explanationVideoUrl" class="goods-explain" :x="draggableX"
      :y="draggableY" :z="10" :w="draggableW" :h="draggableH" :parent="true">
      <div class="flex w100-full h100-full justify-center items-center b_black">
        <img class="absolute video-close" src="./images/close.png" v-if="draggableW == 80"
          @click.stop="draggableVisibleChange" />
        <template v-if="videoWXFirst">
          <img class="video-start" src="./images/video_play_icon2.png" @click="videoFullScreen" />
          <img @click="videoFullScreen" class="absolute video-cover" :src="
              `${detail.explanationVideoUrl}?vframe/png/offset/1/h/140/imageMogr2/thumbnail/80000@`
            " />
        </template>
        <div class="w100-full h100-full" :style="
            `background: url(${`${
              detail.explanationVideoUrl
            }?vframe/png/offset/1/h/140/imageMogr2/thumbnail/80000@`}) no-repeat center center;background-clip:cover;`
          " v-else>
          <video id="video" title="" ref="videoPlayer" width="100%" height="100%" loop="loop" preload autoplay="true"
            playsinline muted="true" x5-video-player-type="h5" webkit-playsinline="true" x-webkit-airplay="true"
            x5-video-orientation="portraint" x5-video-player-fullscreen="true" @click="videoFullScreen"
            :poster="detail.explanationVideoUrl">
            <source :src="detail.explanationVideoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <img class="absolute video-close-large" src="./images/video-close.png" v-if="draggableW != 80"
          @click="videoFullScreen" />
      </div>
      <div class="white absolute text-center draggable-text" @click="videoFullScreen">商品讲解</div>
    </draggable-resizable>
    <van-tabs scrollspy sticky>
      <van-tab title="商品">
        <div class="good_swipe_wrap">
          <!--<div class="goodInfo-video" @click="goodInfoVideo" v-if="detail.videoUrl">
            <img src="./images/goodInfo-video.png" alt="">
            <span>视频介绍</span>
          </div>-->
          <div class="good_swipe">
            <van-swipe @change="swipeChange">
              <van-swipe-item v-if="detail.videoUrl" class="video-swipe-item">
                <div class="video-poster" v-if="isShowVideo" @click="showVideo">
                  <img class="video-cover-img" v-lazy="detail.videoCover" alt="" />
                  <img class="video_play_icon" src="./images/video_play_icon2.png" alt="" />
                </div>
                <div class="video-wrap" v-show="!isShowVideo">
                  <video title="" :src="detail.videoUrl" loop="true" controls preload="none" x5-video-player-type="h5"
                    x5-video-player-fullscreen="true">
                    您的浏览器不支持 video 标签
                  </video>
                </div>
                <!-- <vueMiniPlayer v-else ref="vueMiniPlayer" :video="video" :mutex="true" /> -->
              </van-swipe-item>
              <van-swipe-item v-for="(img, index) in detail.imgUrls" :key="index">
                <img v-lazy="`${img}?imageMogr2/auto-orient/thumbnail/1200000@`" alt="" />
              </van-swipe-item>
              <template #indicator>
                <div class="custom-indicator">{{ current + 1 }}/{{ imgSize }}</div>
              </template>
            </van-swipe>
          </div>
          <div v-if="detail.subscriptList && detail.subscriptList.length" class="absolute z-index2 goods-badge">
            <img v-if="detail.subscriptList[0].code == 'ZL_YH'"
              src="https://nfs.nxin.com/cms_image_2b20d372-40b9-4f14-9a86-82aa779afc5b.png" />
            <img v-else-if="detail.subscriptList[0].code == 'BP'"
              src="https://nfs.nxin.com/cms_image_7adbedb6-c4e8-4a39-864c-4b2943efffbf.png" />
            <img v-else-if="detail.subscriptList[0].code == 'YX'"
              src="https://nfs.nxin.com/cms_image_f2cbd6b5-fb44-4063-9605-df64ba4e33cd.png" />
          </div>
        </div>
        <!--  促销商品信息  -->
        <div class="b_white">
          <div class="good_activity" v-if="
              detail.promotion &&
                detail.promotion.isPromotion === 1 &&
                detail.isVip === 0 &&
                detail.goodsPrice.sellFactPrice
            ">
            <div class="activity_left float-left" v-if="detail.promotion && detail.promotion.giftGoodsId">
              <p class="white f14_rem">
                每人最多领取{{ detail.promotion.promotionLimitation }}{{ detail.mUnitCn }}赠品
              </p>
              <!--            <span class="f_rem11 pad05_r">{{ Number(detail.promotion.marketPrice).toFixed(2)}}</span>
                         <span class='f_rem05 gray_6 white'>{{detail.spec}}</span>-->
              <div class="box10"></div>
              <span>{{ detail.promotion.promotionName }}</span>
            </div>
            <!--  集采  -->
            <div class="activity_left float-left" v-else-if="
                detail.promotion &&
                  detail.promotion.isGroupPurchase === 1 &&
                  detail.promotion.marginStatus === 1
              ">
              <p class="white f14_rem clear">
                <em class="float-left">
                  {{ detail.promotion.isGroupTeam === 0 ? "最小起订量" : "成团达标量" }}
                  {{ detail.promotion.promotionMinimum }}{{ detail.mUnitCn }}
                </em>
                <!--              <em class="t_through f12_rem gray_9 pad10_l ver_sub float-right white">
                               ¥{{ Number(detail.promotion.marketPrice).toFixed(2) }}
                             </em>-->
              </p>
              <div class="box10"></div>
              <p class="clear">
                <!--              <em class="f_rem11 pad05_r white float-left">
                               ￥ <i class="f26_rem">{{ Number(detail.promotion.promotionPrice).toFixed(2) }}</i> {{detail.spec}}
                             </em>-->
                <span class="float-left">集采价</span>
              </p>
            </div>
            <div class="activity_left float-left" v-else>
              <p class="white f14_rem" v-if="detail.promotion && detail.promotion.promotionType === 'BUY_GIFTS'">
                每人限赠{{ detail.promotion.promotionLimitation }}件
                <!--              <span class="t_through f12_rem gray_9 pad10_l ver_sub">¥{{ Number(detail.promotion.marketPrice).toFixed(2) }}</span>-->
              </p>
              <p class="white f14_rem" v-else>
                每人限购{{ detail.promotion.promotionLimitation }}件
              </p>
              <!--            <span v-if="detail.isShowPrice == 1" class="f_rem11 pad05_r">{{ Number(detail.promotion.promotionPrice).toFixed(2) }}</span>
                         <span v-if="detail.isShowPrice == 1" class='f_rem05 gray_6 white'>{{detail.spec}}</span>-->
              <div class="box10"></div>
              <span>{{ detail.promotion.promotionName }}</span>
            </div>
            <div class="float-left activity_right" v-if="
                (detail.promotion &&
                  detail.promotion.isPromotion === 1 &&
                  detail.promotion.isGroupPurchase === 1 &&
                  detail.promotion.marginStatus === 1) ||
                  (detail.promotion &&
                    detail.promotion.isPromotion === 1 &&
                    detail.promotion.isGroupPurchase !== 1)
              ">
              <p class="red f12_rem">距结束仅剩</p>
              <van-count-down :time="time">
                <template #default="timeData">
                  <span class="block">{{ timeData.days }}</span>
                  <span class="colon">天</span>
                  <span class="block">{{ timeData.hours }}</span>
                  <span class="colon">时</span>
                  <span class="block">{{ timeData.minutes }}</span>
                  <span class="colon">分</span>
                </template>
              </van-count-down>
            </div>
          </div>
        </div>
        <div class="b_white good_info">
          <div class="good_price_collect">
            <div class="good_price_wrap flex-auto" v-if="detail.goodsPrice.sellFactPrice">
              <!-- goodsPriceMemberLevel  1 VIP会员 2 养殖会员 3 小站会员 4 运营中心会员 -->
              <template v-if="memberVip.id">
                <img class="h20 mar5-r" v-if="detail.goodsPriceMemberLevel == '1'"
                  src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
                <img class="h20 mar5-r" v-if="detail.goodsPriceMemberLevel == '2'"
                  src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
                <img class="h20 mar5-r" v-if="detail.goodsPriceMemberLevel == '3'"
                  src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
                <img class="h20 mar5-r" v-if="detail.goodsPriceMemberLevel == '4'"
                  src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
                <img class="h20 mar5-r" v-if="detail.goodsPriceMemberLevel == '5'"
                  src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
                <span class="f12_rem gray_2 ver_sub mar15-r">
                  <span class="red">¥ <span class="f20_rem">{{ detail.goodsPrice.sellFactPrice }} </span></span>{{
                  detail.spec }}
                </span>
                <span v-if="
                    Number(detail.goodsPrice.sellFactPrice) < Number(detail.goodsPrice.sellPrice)
                  " class="t_through f12_rem gray_9">¥{{ detail.goodsPrice.sellPrice }}</span>
              </template>
              <template v-else>
                <span class="f12_rem gray_2 ver_sub mar15-r">
                  <span class="red">¥ <span class="f20_rem">{{ detail.goodsPrice.sellFactPrice }} </span></span>{{
                  detail.spec }}
                </span>
                <img class="h15 mar5-r" v-if="detail.goodsPriceMemberLevel == '1'"
                  src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
                <img class="h15 mar5-r" v-if="detail.goodsPriceMemberLevel == '2'"
                  src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
                <img class="h15 mar5-r" v-if="detail.goodsPriceMemberLevel == '3'"
                  src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
                <img class="h15 mar5-r" v-if="detail.goodsPriceMemberLevel == '4'"
                  src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
                <img class="h15 mar5-r" v-if="detail.goodsPriceMemberLevel == '5'"
                  src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
                <span class="good_vip_price" v-if="detail.vipMoney > 0">
                  ￥{{ detail.vipMoney }}
                  <!-- <img src="./images/good_vip_icon.png" alt=""> -->
                </span>
              </template>
            </div>
            <div class="good_price_wrap" v-else-if="detail.goodsPrice.sellFactPrice !== null">
              <span class="f12_rem gray_2 ver_sub">
                <span class="gray_6"> <span class="f20_rem">暂无价格 </span></span>
              </span>
            </div>
            <div class="clear">
              <div class="good_collect float-left pad10_r" @click="qr">
                <img src="./images/good_poster_icon.png" alt="" />
                <p class="gray_2 f10_rem">生成海报</p>
              </div>
              <div class="good_collect float-left pad10_r" @click="goodCollect">
                <img v-if="isGoodCollect" src="./images/good_collected_icon.png" alt="" />
                <img v-else src="./images/good_collect_icon.png" alt="" />
                <p class="gray_2 f10_rem">收藏</p>
              </div>
              <div v-if="isShare" class="good_collect float-left" @click="share">
                <img src="https://nfs.nxin.com/cms_image_8a8d8420-a6a1-4690-a2d3-750e2a9bbc72.png" alt="" />
                <p class="gray_2 f10_rem">分享</p>
              </div>
            </div>
          </div>
          <!-- <div class="good_price_old" v-if="Number(detail.goodsPrice.sellFactPrice) < Number(detail.goodsPrice.sellPrice)">
            <span class="t_through f12_rem gray_9">¥{{detail.goodsPrice.sellPrice}}</span>
          </div> -->
          <div class="good_optimization_wrap" v-if="detail.isOptimization == 1" @click="nxyxShow = true">
            <span class="good_optimization">优选</span>
            <span class="gray_3 pad5_lr">用心·为您·甄选</span>
            <van-icon name="arrow" size="12px" color="#666" />
          </div>
          <div class="gray_2 ellipsis_two">
            <img class="h20 mar5-r" v-if="detail.isShowFarmersDayLabel"
              src="https://nfs.nxin.com/cms_image_546d8af9-8df0-47d0-8fe7-df4e51e209e7.png" />
            <span class="h20 relative good_vip mar5_r" v-if="detail.isSelfOperated == 1">自营</span>
            <span class="h20 relative good_vip mar5_r" v-if="detail.isPrescription == 1">处方药</span>
            <template v-if="detail.goodsTagList && detail.goodsTagList.length">
              <span class="h20 relative good_vip mar5_r" v-for="tag in detail.goodsTagList">{{tag}}</span>
            </template>
            <img class="h20 mar5-r" v-if="detail.shopDtlEntity.isOthersGoodsReceipt == 1"
              src="./images/gift_label.png" />
            <span class="fb"> {{ detail.name }}</span>
          </div>
          <div class="box5"></div>
          <p class="gray_9 f12_rem gray_9">{{ detail.nmGoodsIntroduce }}</p>
          <div class="box5"></div>
          <div class="good_totalSale">
            <!--<p class="gray_2 f12_rem" v-if="detail.isOa==0 || detail.stockType ==1 || detail.stockType ==2">
              <template v-if="detail.promotion.isPromotion == 1 && detail.isVip == 0">
                <span v-if="detail.promotion.isGroupPurchase==1">
                  集采剩余数量 {{detail.promotion.promotionRemain}} 件
                  商品库存：{{detail.currQuantity}} 件
                </span>
                <span v-else>
                  剩余数量： {{detail.promotion.promotionRemain}} 件
                </span>
              </template>
              <span class="gray_2 f12_rem" v-else-if="detail.goodsPrice.sellFactPrice">
                剩余数量：{{detail.currQuantity}} 件
              </span>
            </p>-->
            <p class="gray_9 f12_rem" v-if="detail.goodsPrice.sellFactPrice">
              累计销量 {{ detail.totalSales ? detail.totalSales : 0 }}
            </p>
            <p class="gray_2 f12_rem good_location">{{ detail.goodsShop.areaName }}</p>
          </div>
        </div>
        <!--        <template v-if="detail.isVip == 1 || (detail.isVip == 0 && detail.vipMoney)">
          <div class="box15"></div>
          <div class="b_white good_info">
            <div class="clear">
              <p v-if="detail.isVip == 1">
                VIP会员专享 预计返现金券 {{detail.vipRebateCouponNum}} 张
                <img src="./images/help_icon.png" @click="vipDeclareShow = true" class="mar10_l vertical_m mar4_t" width="20" style="vertical-align: initial;"/>
              </p>
              <span class=" pad20_r mui-ellipsis w300 " v-if="detail.isVip == 0 && detail.vipMoney">
            <p>
              <img src="./images/vip.png" class="mar10_l vertical_m mar4_t" width="35" style="vertical-align: initial;"/>
              <span class="red f15 ">¥</span>
              <span class="red f18 fb pad10_r">{{detail.vipMoney}}</span>
            </p>
            <p>
                <span class="gray_3">预计返现金券{{detail.vipRebateCouponNum}}张  VIP会员专享
                  <img src="./images/help_icon.png" @click="vipDeclareShow = true" class="mar10_l vertical_m mar4_t" width="20" style="vertical-align: initial;"/>
                </span>
              <a class="vip_open" href="/mob/memberInfo/toVipIntroduce">开通vip</a>
            </p>
          </span>
            </div>
          </div>
        </template>-->
        <div class="box10"></div>
        <!--优惠券/促销-->
        <div class="good_operation b_white">
          <ul class="discounts_info">
            <li class="clear" @click="couponDialog" v-if="
                detail.isVip == 1 ||
                  (detail.isVip == 0 && detail.vipMoney) ||
                  goodsCouponName ||
                  (loadGoods.maxCashCount && loadGoods.maxCashCount > 0)
              ">
              <span class="float-left pad10_r f13_rem fb">优惠</span>
              <div class="float-left">
                <div class="discounts_vip" v-if="detail.isVip == 1 || (detail.isVip == 0 && detail.vipMoney)">
                  <img class="h16 mar5-r" v-if="detail.goodsPriceMemberLevel === '1'"
                    src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
                  <img class="h16 mar5-r" v-if="detail.goodsPriceMemberLevel === '2'"
                    src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
                  <img class="h16 mar5-r" v-if="detail.goodsPriceMemberLevel === '3'"
                    src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
                  <img class="h16 mar5-r" v-if="detail.goodsPriceMemberLevel === '4'"
                    src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
                  <img class="h16 mar5-r" v-if="detail.goodsPriceMemberLevel === '5'"
                    src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
                  <!-- <img src="./images/discounts_vip_icon.png" /> -->
                  <span class="f12_rem" v-if="detail.vipRebateCouponNum !== 0">预计返现金券{{ detail.vipRebateCouponNum
                    }}张</span>
                </div>
                <div class="mar15_b" v-if="goodsCouponName">
                  <span class="discounts_info_icon">优惠券</span>
                  <span class="f12_rem">{{ goodsCouponName }}</span>
                </div>
                <div class="mar15_b" v-if="loadGoods.maxCashCount && loadGoods.maxCashCount > 0">
                  <span class="discounts_info_icon">平台券</span>
                  <span class="f12_rem">最高可用现金券抵扣{{ loadGoods.maxCashCount }}元</span>
                </div>
              </div>
              <img class="good_operation_icon" v-if="
                  detail.isVip == 1 || (detail.isVip == 0 && detail.vipMoney) || goodsCouponName
                " src="./images/good_operation_icon.png" alt="" />
            </li>
            <li class="clear" @click="discountsShow = true"
              v-if="detail.promotion && detail.promotion.giftGoodsId && detail.isVip == 0">
              <span class="float-left pad10_r f13_rem fb">促销</span>
              <div class="float-left">
                <div class="mar15_b" v-if="detail.promotion && detail.promotion.giftGoodsId && detail.isVip == 0">
                  <span class="discounts_info_icon">买赠</span>
                  <span class="f12_rem">{{ detail.promotion.promotionName }}</span>
                </div>
              </div>
              <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
            </li>

            <li class="clear" @click="packageShow = true" v-if="packageSkuList && packageSkuList.length > 0">
              <span class="float-left pad10_r f13_rem fb">套餐</span>
              <div class="float-left">
                <div class="mar15_b">
                  <span class="ellipsis w240 inlineblock ver_bottom f12_rem">
                    共{{ packageSkuList.length }}{{ detail.mUnitCn }}商品
                  </span>
                </div>
              </div>
              <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
            </li>
          </ul>
        </div>
        <!-- 集采-->
        <template v-if="detail.promotion && detail.promotion.isGroupPurchase === 1 && detail.isVip === 0">
          <div class="box10"></div>
          <div class="good_operation b_white">
            <ul>
              <li>
                <span class="pad10_r f13_rem fb">集采</span>
                <!--<img class="good_operation_icon" src="./images/good_operation_icon.png" alt="">-->
              </li>
              <li class="item_progress">
                <p>
                  <span class="pad10_r f13_rem fb">活动总量</span>
                  <span class="f12_rem">
                    {{ detail.promotion.promotionStock }}{{ detail.mUnitCn }}
                  </span>
                </p>
                <p class="box15"></p>
                <van-progress v-if="detail.promotion.completionRate > 100" :percentage="100" color="#ff0023" />
                <van-progress v-else :percentage="detail.promotion.completionRate" color="#ff0023" />
              </li>
              <li v-if="detail.promotion.isGroupTeam === 0" @click="collectShow = true">
                <span class="pad10_r f13_rem fb">集采规则说明</span>
                <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
              </li>
              <li v-else @click="groupShow = true">
                <span class="pad10_r f13_rem fb">拼团规则说明</span>
                <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
              </li>
              <!-- 拼团信息 -->
              <li v-if="detail.promotion.isGroupTeam == 1 && detail.isVip == 0">
                <a @click.prevent="toAllTeam()">
                  <span class="f12_rem">已有<em class="red">{{ detail.purchaseCount }}</em>人购买，有<em class="red">{{
                      detail.teamCount }}</em>个团可直接参与</span>
                  <van-icon class="gray_6 good_operation_back" size="16" name="arrow" />
                </a>
                <!--                <ul class="mui-table-view d_shop border_b">
                  <li class="mui-table-view-cell mui-media " v-for="(team,index) in detail.groupTeamList" :key="index">
                    <div class="mui-media-body gray_3 mui-row f12 ">
                      <div class="mui-col-xs-2 t_center">
                        <img class="mimg2 radius_circle mui-pull-left" :src="team.initiatorHeadIcon"
                             :onerror="team.initiatorHeadIcon = './images/ctmrpic.png'">
                      </div>
                      <div class="mui-col-xs-10 clear mui-row">
                        <span class="pad15_t inlineblock mui-col-xs-4">{{team.initiatorName}}</span>
                        <span class="pad15_t inlineblock mui-col-xs-4">还差
                        <em class="red">{{team.goodsLackNum}}件</em>成团</span>
                        <div class="inlineblock d_xiadan t_right mui-col-xs-4">
                          <a @click.prevent="toJoinTeam(team.id)">
                            <em class="cur f12" data="1">去参团</em>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>-->
              </li>
            </ul>
          </div>
        </template>
        <div class="box10"></div>
        <!-- 阶梯价 -->
        <template v-if="
            detail.goodsPrice &&
              detail.goodsPrice.commonLaddersPrice &&
              detail.goodsPrice.commonLaddersPrice.goodsPriceList &&
              detail.goodsPrice.commonLaddersPrice.goodsPriceList.length
          ">
          <div class="bg-white fb pad15 flex flex-item1 justify-between ladders-price">
            <div v-for="(item, index) in detail.goodsPrice.commonLaddersPrice.goodsPriceList"
              class="item flex flex-column justify-center items-center" :key="item.level"
              :class="{ active: index === laddersPriceIndex }" @click="laddersChoose(index)">
              <div class="active-icon f20" v-if="item.unitRatioStr">{{ item.unitRatioStr }}</div>
              <div class="active-icon f20" v-if="!item.unitRatioStr && index === laddersPriceIndex">
                当前价
              </div>
              <div class="flex justify-center items-baseline mar5-t">
                <div class="f15">¥</div>
                <div class="f20">{{ priceSplit(item.price)[0] }}</div>
                <div class="f15">{{ priceSplit(item.price)[1] }}</div>
              </div>
              <div class="f13 gray3">
                <template v-if="index == detail.goodsPrice.commonLaddersPrice.goodsPriceList.length - 1">
                  ≥{{ item.minQuantity }}
                </template>
                <template v-else>
                  <template v-if="item.minQuantity == item.maxQuantity">
                    {{ item.minQuantity }}
                  </template>
                  <template v-else>
                    {{ item.minQuantity }}~{{ item.maxQuantity }}
                  </template>
                </template>
                {{ detail.mUnitCn }}
              </div>
            </div>
          </div>
          <div class="box10"></div>
        </template>
        <div class="good_operation b_white">
          <ul>
            <!-- 套装商品 -->
            <!--            <div class="z_format b_white border_t border_b f12 gray_6 mui-clearfix" v-if="detail.isGroup == 1 && detail.goodsList">
              <span class="pad10_r f13_rem fb red">套装商品</span>
              <div v-for="good in detail.goodsList" :key="good.goodsId">
                <a :href="`/vm/goodDetails/${good.goodsId}`">
                  <img class="float-left" style="height: 90px; width: 90px;" :src="`${good.picUrl}?imageView2/0/w/42/h/42`" alt="">
                  <div class="float-left pad5_tb w75">
                    <p class="f14_rem gray_2 ellipsis">{{good.name}}</p>
                  </div>
                </a>
              </div>
            </div>-->

            <li @click="choosedCard">
              <span class="pad10_r f13_rem fb">
                <template v-if="specGroupCheckedName">
                  已选
                </template>
                <template v-else>
                  请选择
                </template>
              </span>
              <!-- skuSpecsIndex -->
              <span v-if="detail.commonLaddersPrice">
                {{ specGroupCheckedName }}
              </span>
              <span v-else class="f12_rem">
                {{ detail.specType === 1 ? detail.skuSpecsIndex : detail.spec }}， ×{{ addCartNum }}
              </span>
              <img class="good_operation_icon" v-if="detail.currQuantity > 0" src="./images/good_operation_icon.png"
                alt="" />
            </li>

            <li @click="distributionShow = true">
              <span class="pad10_r f13_rem fb">配送方式</span>
              <span class="f12_rem pad12_r" v-if="isZt">买家自提</span>
              <span class="f12_rem" v-if="isPs">卖家配送</span>
              <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
            </li>
            <!--addChooseShow addressDialog()-->
            <li class="flex" @click="addressDialog" v-if="isPs">
              <span class="pad10_r flex-shrink f13_rem fb">送至</span>
              <!--未登录情况获取当前定位信息-->
              <span class="flex-auto flex f12_rem">
                <img class="position_icon self-center" src="./images/position_icon.png" style="margin: 0 5px 0 0;" v-if="
                    !userInfo.id ||
                      !deliveryVO.memberDeliveryEntity ||
                      !deliveryVO.memberDeliveryEntity.deliveryId
                  " />
                <span class="f12_rem flex flex-auto text-overflow" style="width: 0;" v-if="
                    deliveryVO.memberDeliveryEntity && deliveryVO.memberDeliveryEntity.areaFullName
                  ">{{ deliveryVO.memberDeliveryEntity.areaFullName }}</span>
                <span class="f12_rem" v-else>请先设置收货地址</span>
                <span class="f12_rem flex-shrink mar20-r red" v-if="parseInt(deliveryVO.isMatching) === 0">
                  该地区暂不支持配送</span>
              </span>
              <img class="good_operation_icon" src="./images/good_operation_icon.png" alt="" />
            </li>
            <li v-if="isPs && freightList && freightList.length > 0">
              <span class="pad10_r f13_rem fb">运费</span>
              <span class="f12_rem">已选择</span>
              <span class="f13_rem red"> {{ freight.transModeCn }}</span>
              {{ freight.freightMoney }}元/吨
              <span class="f12_rem"> 具体运费根据购买数量决定</span>
              <img class="good_operation_icon" @click="freightShow = true" src="./images/good_operation_icon.png"
                alt="" />
            </li>
            <li v-else-if="isPs">
              <span class="pad10_r f13_rem fb">运费</span>
              <span class="f12_rem">{{ freight.freightMoney }}</span>
            </li>
          </ul>
        </div>
        <!-- 广告-->
        <div class="box10" v-if="detail.isOptimization == 1"></div>
        <!--<div v-if="detail.isOptimization == 1" class="good_adv">
          <img src="./images/nxyx.jpg"/>
        </div>-->
        <!--        <div class="box10" v-if="detail.isPrescription == 1"></div>
        <div v-if="detail.isPrescription == 1" class="good_adv">
          <img src="./images/chufang-info.png"/>
        </div>-->
        <div class="box10"></div>
        <div class="good_adv" v-for="(ad, index) in adList" :key="index">
          <img :src="ad.img" @click="toImg(ad.url)" alt="" />
        </div>
        <div class="nxin_live_wrap">
          <img class="nxin_live" src="./images/nxin-live.gif" alt="" @click="liveToUrl" />
          <span class="nxin_live_close" @click="liveClose">
            <img src="./images/nxin-live-close.png" alt="" />
          </span>
        </div>
      </van-tab>
      <van-tab title="评价">
        <div v-if="detail.goodsDyDtlList && detail.goodsDyDtlList.length > 0"
          class="bg-white pad15-lr pad10-t radius10">
          <a target="_blank" :href="`${VUE_APP_SC}vm2/qa/qa?spuId=${detail.spuId}`">
            <div class="flex pad10-b">
              <div class="f15_rem fb gray_2 flex-auto">
                商品答疑({{ detail.goodsDyDtlList.length }})
              </div>
              <div class="flex items-center">
                <div class="flex-auto gray_9">查看全部</div>
                <van-icon class="gray_9" size="16" name="arrow" />
              </div>
            </div>
          </a>
          <div class="border-t"></div>
          <div class="flex pad5-t">
            <div class="flex-auto fb f14_rem gray3 text-overflow mar10-r">
              <img src="https://nfs.nxin.com/cms_image_47f250c0-1508-44fb-b8df-32bf6310febf.png" class="wh28 mar5-r" />
              {{ detail.goodsDyDtlList[0].question }}
            </div>
            <div v-if="detail.goodsDyDtlList[0].personAmount" class="flex-shrink">
              {{ detail.goodsDyDtlList[0].personAmount }}人同问
            </div>
          </div>
          <div class="pad10-b text-overflow">
            <img src="https://nfs.nxin.com/cms_image_6c727a70-464e-4f5f-b281-3bb2f2f0a46c.png" class="wh28 mar5-r" />{{
            detail.goodsDyDtlList[0].answer }}
          </div>
        </div>
        <div class="box15"></div>
        <div class="bg-white pad15-lr pad10-t radius10">
          <a target="_blank" :href="`${VUE_APP_SC}vm2/comment/list/list?spuId=${detail.spuId}`">
            <div class="flex pad10-b">
              <div class="f15_rem fb gray_2 flex-auto">
                商品评价
                <template v-if="goodsEvaluateCollect.incReplyAllAmount">
                  ({{ goodsEvaluateCollect.incReplyAllAmount }})
                </template>
              </div>
              <div class="flex items-center">
                <div class="flex-auto gray_9">{{ goodsEvaluateCollect.goodsEvaRate }}</div>
                <van-icon class="gray_9" size="16" name="arrow" />
              </div>
            </div>
            <template v-if="goodsEvaluateList && goodsEvaluateList.length">
              <template v-for="(item, index) in goodsEvaluateList">
                <EvaluateItemItem class="item" type="user" ellipsis :data="item" :key="index" />
                <div class="line mar20-tb bor-f0-t" v-if="goodsEvaluateList.length > 1" :key="`a${index}`"></div>
              </template>
            </template>

            <div v-else class="text-center">暂无评价</div>
          </a>
          <div class="border-t"></div>
        </div>
        <div class="box15"></div>
        <div class="good_shop b_white" v-if="detail.goodsShop.audit == 1">
          <div class="clear" @click="shopQBHP">
            <img class="float-left good_shop_img" v-if="detail.goodsShop.face"
              :src="`${detail.goodsShop.face}?imageView2/0/w/120/h/120`" alt="" />
            <img class="float-left good_shop_img" v-else
              src="https://filesouthcdn.nxin.com/nxsc_1498667349766037509690473475377.png?imageView2/1/w/120/h/120"
              alt="" />
            <!--        <img class="float-left good_shop_img" src="./images/good_shop_img.png" alt="">-->
            <div class="float-left w75">
              <p class="f14_rem gray_2">{{ detail.goodsShop.name }}</p>
              <div class="box5"></div>
              <p class="f12_rem gray_2 ellipsis">主营：{{ detail.goodsShop.businessScope }}</p>
              <div class="box5"></div>
              <p class="f12_rem gray_2 ellipsis">地址：{{ detail.goodsShop.areaName }}</p>
            </div>
          </div>
          <div class="box15"></div>
          <div class="good_shop_btn">
            <span class="mar15_r" @click="shopCollect">
              <img v-if="isShopCollect" src="./images/shop_collected_icon.png" />
              <img v-else src="./images/shop_collect_icon.png" />
              收藏店铺
            </span>
            <span @click="shopQBHP">
              <img src="./images/good_shop_icon.png" alt="" />
              进入店铺
            </span>
          </div>
        </div>
      </van-tab>
      <van-tab title="详情">
        <div class="box15"></div>
        <div class="good_details b_white">
          <van-tabs>
            <van-tab title="图文详情">
              <div class="good_details_main" v-html="detailHtml" v-lazy-container="{ selector: 'img' }"></div>
              <p class="mui-text-center pad10_b" @click="riskWarning">
                <span class="f12 yahei red">交易风险提示</span>
              </p>
            </van-tab>
            <van-tab title="规格参数">
              <div class="good_details_main" v-html="detailContent.itemV2" v-if="!detail.goodsContractVoList"></div>
              <div class="good_details_main" v-if="detail.goodsContractVoList">
                <div v-html="detailContent.itemV2"></div>
                <div class="box10"></div>
                <div class="relative">电子合同属性</div>
                <div class="box15"></div>
                <p class="red">以下带*选项为签署电子合同默认选项，如有疑问可联系店主进行调整。</p>
                <div class="clear" v-for="(goodsContract, index) in detail.goodsContractVoList" :key="index">
                  <div class="box10"></div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '支付方式'">
                    <label class="pull-left  text-right">支付方式</label>
                    <div class="pull-left">
                      <div v-if="goodsContract.contractAttrDefaultValue === '多次支付'">
                        <p class="normal gray_6">
                          *多次支付：本合同签署后【
                          {{ goodsContract.contractData.contractData1 }} 】日内付【
                          {{ goodsContract.contractData.contractData2 }}
                          】%款项，产品、货物装车/装船后当日内付【
                          {{ goodsContract.contractData.contractData3 }} 】%款项，确认收货后【
                          {{ goodsContract.contractData.contractData4 }} 】日内付【
                          {{ goodsContract.contractData.contractData5 }} 】%款项，支付首笔款后【
                          {{ goodsContract.contractData.contractData6 }} 】日内发货。
                        </p>
                        <div v-for="(goodsContractValue,
                          index) in goodsContract.goodsContractValueList" :key="index">
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '先款后货'">
                            先款后货：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }}
                            】日内付全款，付款后【
                            {{ goodsContractValue.goodsContractData.contractData2 }} 】日内发货。
                          </p>
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '先货后款'">
                            先货后款：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }}
                            】日内发货，验收合格后【
                            {{ goodsContractValue.goodsContractData.contractData2 }} 】日内付全款。
                          </p>
                        </div>
                      </div>
                      <div v-if="goodsContract.contractAttrDefaultValue === '先款后货'">
                        <div v-for="goodsContractValue in goodsContract.goodsContractValueList"
                          :key="goodsContractValue">
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '多次支付'">
                            多次支付：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }} 】日内付【
                            {{ goodsContractValue.goodsContractData.contractData2 }}
                            】%款项，产品、货物装车/装船后当日内付【
                            {{ goodsContractValue.goodsContractData.contractData3 }}
                            】%款项，确认收货后【
                            {{ goodsContractValue.goodsContractData.contractData4 }} 】日内付【
                            {{ goodsContractValue.goodsContractData.contractData5 }}
                            】%款项，支付首笔款后【
                            {{ goodsContractValue.goodsContractData.contractData6 }} 】日内发货。
                          </p>
                        </div>
                        <p class="normal gray_6">
                          *先款后货：本合同签署后【
                          {{ goodsContract.contractData.contractData1 }} 】日内付全款，付款后【
                          {{ goodsContract.contractData.contractData2 }} 】日内发货。
                        </p>
                        <div v-for="goodsContractValue in goodsContract.goodsContractValueList"
                          :key="goodsContractValue">
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '先货后款'">
                            先货后款：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }}
                            】日内发货，验收合格后【
                            {{ goodsContractValue.goodsContractData.contractData2 }} 】日内付全款。
                          </p>
                        </div>
                      </div>
                      <div v-if="goodsContract.contractAttrDefaultValue === '先货后款'">
                        <div v-for="goodsContractValue in goodsContract.goodsContractValueList"
                          :key="goodsContractValue">
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '多次支付'">
                            多次支付：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }} 】日内付【
                            {{ goodsContractValue.goodsContractData.contractData2 }}
                            】%款项，产品、货物装车/装船后当日内付【
                            {{ goodsContractValue.goodsContractData.contractData3 }}
                            】%款项，确认收货后【
                            {{ goodsContractValue.goodsContractData.contractData4 }} 】日内付【
                            {{ goodsContractValue.goodsContractData.contractData5 }}
                            】%款项，支付首笔款后【
                            {{ goodsContractValue.goodsContractData.contractData6 }} 】日内发货。
                          </p>
                          <p class="normal gray_6" v-if="goodsContractValue.goodsContractValue === '先款后货'">
                            先款后货：本合同签署后【
                            {{ goodsContractValue.goodsContractData.contractData1 }}
                            】日内付全款，付款后【
                            {{ goodsContractValue.goodsContractData.contractData2 }} 】日内发货。
                          </p>
                        </div>
                        <p class="normal gray_6">
                          *先货后款：本合同签署后【
                          {{ goodsContract.contractData.contractData1 }} 】日内发货，验收合格后【
                          {{ goodsContract.contractData.contractData2 }} 】日内付全款。
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '运输方式'">
                    <div class="box10"></div>
                    <div class="relative">运输方式</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '汽运'">
                        *汽运；火运；船运；物流
                      </p>
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '火运'">
                        汽运；*火运；船运；物流
                      </p>
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '船运'">
                        汽运；火运；*船运；物流
                      </p>
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '物流'">
                        汽运；火运；船运；*物流
                      </p>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '运费由谁承担'">
                    <div class="box10"></div>
                    <div class="relative">运费由谁承担</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '卖家'">
                        *卖家；买家
                      </p>
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '买家'">
                        卖家；*买家
                      </p>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '诉讼所在地'">
                    <div class="box10"></div>
                    <div class="relative">诉讼所在地</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue === '合同签订地'">
                        *合同签订地；合同履行地；原告住所地；被告住所地；甲方所在地；乙方所在地
                      </p>
                      <p class="normal gray_6" v-else-if="goodsContract.contractAttrDefaultValue === '合同履行地'">
                        合同签订地；*合同履行地；原告住所地；被告住所地；甲方所在地；乙方所在地
                      </p>
                      <p class="normal gray_6" v-else-if="goodsContract.contractAttrDefaultValue === '原告住所地'">
                        合同签订地；合同履行地；*原告住所地；被告住所地；甲方所在地；乙方所在地
                      </p>
                      <p class="normal gray_6" v-else-if="goodsContract.contractAttrDefaultValue === '被告住所地'">
                        合同签订地；合同履行地；原告住所地；*被告住所地；甲方所在地；乙方所在地
                      </p>
                      <p class="normal gray_6" v-else-if="goodsContract.contractAttrDefaultValue === '甲方所在地'">
                        合同签订地；合同履行地；原告住所地；被告住所地；*甲方所在地；乙方所在地
                      </p>
                      <p class="normal gray_6" v-else-if="goodsContract.contractAttrDefaultValue === '乙方所在地'">
                        合同签订地；合同履行地；原告住所地；被告住所地；甲方所在地；*乙方所在地
                      </p>
                    </div>
                  </div>
                  <div class="clearfix normal" v-if="goodsContract.contractAttrName === '短溢量'">
                    <div class="box10"></div>
                    短溢量：±【
                    {{ goodsContract.contractAttrDefaultValue }}
                    】%，在此范围内根据实际交货数量及本合同约定销售单价计算最终合同价款。
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '客户对货品质量标准的特别约定'">
                    <div class="box10"></div>
                    <div class="relative">客户对货品质量标准的特别约定</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue">
                        {{ goodsContract.contractAttrDefaultValue }}
                      </p>
                      <p class="normal gray_6" v-else>无</p>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '双方对赔付拒收标准的特别约定'">
                    <div class="box10"></div>
                    <div class="relative">双方对赔付拒收标准的特别约定</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue">
                        {{ goodsContract.contractAttrDefaultValue }}
                      </p>
                      <p class="normal gray_6" v-else>无</p>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '双方对违约责任的特别约定'">
                    <div class="box10"></div>
                    <div class="relative">双方对违约责任的特别约定</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue">
                        {{ goodsContract.contractAttrDefaultValue }}
                      </p>
                      <p class="normal gray_6" v-else>无</p>
                    </div>
                  </div>
                  <div class="clear f14" v-if="goodsContract.contractAttrName === '电子合同补充条款'">
                    <div class="box10"></div>
                    <div class="relative">电子合同补充条款</div>
                    <div class="pull-left">
                      <p class="normal gray_6" v-if="goodsContract.contractAttrDefaultValue">
                        {{ goodsContract.contractAttrDefaultValue }}
                      </p>
                      <p class="normal gray_6" v-else>无</p>
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="其他说明">
              <div class="good_details_main" id="itemV3" v-html="detailContent.itemV3"></div>
            </van-tab>
          </van-tabs>
          <div>
            <img class="w100-full" src="./images/good-detail.jpg" />
          </div>
        </div>
        <div class="box15"></div>
      </van-tab>
    </van-tabs>
    <template v-if="detail.isCombination && detail.combinationOrderStatus == 1">
      <!-- 拼单 -->
      <div class="good_footer_wrap b_white">
        <div class="flex flex-item1 white  group-buying">
          <div class="flex mar12-lr justify-center items-center item radius30 btn" @click="addCart(2)">
            原价购买
          </div>
          <router-link class="mar12-lr item" :to="`/groupBuying?id=${detail.combinationOrderId}`">
            <div class="flex flex-column justify-center white items-center radius30 btn">
              <div>立即拼单</div>
              <div v-if="detail.combinationPriceType == 1 || detail.combinationPriceType == 3" class="f13">
                ￥{{ detail.minCombinationPrice }}-{{ detail.maxCombinationPrice }}
              </div>
              <div v-else class="f13">￥{{ detail.singleCombinationPrice }}</div>
            </div>
          </router-link>
        </div>
        <div class="footer_iphone"></div>
      </div>
    </template>
    <!-- <div class="footer_iphone"></div> -->
    <div class="good_footer_wrap b_white" v-else-if="isShowFoot">
      <div class="good_footer">
        <div class="good_footer_item_wrap">
          <div @click="shopQBHP" class="good_footer_item">
            <!--<i class="iconfont icon-mdmj gray_2 f20_rem"></i>-->
            <van-icon name="shop-o" size="20" />
            <p class="f11_rem gray_2">店铺</p>
          </div>
          <div v-if="isShare" class="good_footer_item" @click="contactService">
            <!--<i class="iconfont icon-fenxiang1 gray_2 f22_rem"></i>-->
            <img src="https://nfs.nxin.com/cms_image_daa552a1-4c86-416a-b54f-5c55c9fba6cd.png" height="20" />
            <p class="f11_rem gray_2">客服</p>
          </div>
          <div @click="cart" class="good_footer_item">
            <span v-if="countCart > 0" class="mui-badge" style="left: 34%;">{{
              countCart > 99 ? "99+" : countCart
              }}</span>
            <!--<i class="iconfont icon-jhc gray_2 f26_rem"></i>-->
            <van-icon name="shopping-cart-o" size="20" />
            <p class="f11_rem gray_2">进货车</p>
          </div>
        </div>
        <div class="good_footer_btn_wrap clear" v-if="detail.currQuantity <= 0">
          <div class="good_footer_btn b_graya9 white float-right btn_enquiry">已售完</div>
        </div>
        <div class="good_footer_btn_wrap clear" v-else>
          <template v-if="
              detail.promotion &&
                detail.promotion.isGroupPurchase == 1 &&
                detail.promotion.isGroupTeam == 0 &&
                detail.promotion.marginStatus == 1
            ">
            <div class="good_footer_btn b_ff6001 white float-left" @click="addCart(2)">
              市场价购买
            </div>
            <div class="good_footer_btn b_red white float-left" @click="addCart(3)">集采价购买</div>
          </template>
          <template v-else-if="
              detail.promotion &&
                detail.promotion.isGroupPurchase == 1 &&
                detail.promotion.isGroupTeam == 1 &&
                detail.promotion.marginStatus == 1
            ">
            <!-- 集采-拼团 -->
            <!--@click="buy(2)"-->
            <div class="good_footer_btn b_ff6001 white float-left" @click="addCart(2)">
              市场价购买
            </div>
            <div class="good_footer_btn b_red white float-left" @click="addCart(3)">发起拼团</div>
          </template>
          <template v-else>
            <div class="good_footer_btn b_fff2f4 red bor_red float-left" v-if="detail.goodsPrice.sellFactPrice > 0"
              @click="addCart(1)">
              加入进货车
            </div>
            <div class="good_footer_btn b_red white float-left" v-if="detail.goodsPrice.sellFactPrice > 0"
              @click="addCart(0)">
              {{
              detail.minOrderQuantity > 1
              ? `${detail.minOrderQuantity}${detail.mUnitCn}起购`
              : "立即购买"
              }}
            </div>
            <div class="good_footer_btn b_red white float-right btn_enquiry"
              v-if="detail.goodsPrice.sellFactPrice !== null && !detail.goodsPrice.sellFactPrice" @click="buy(0)">
              点击询价
            </div>
          </template>
        </div>
      </div>
      <div class="footer_iphone"></div>
    </div>
    <div class="share_mask" v-show="isShowShare" @click="isClose">
      <img src="./images/share.png" alt="" />
    </div>
    <!-- <div class="video-wrap">
      <div class="video-mask" @click="videoMask"></div>
      <video :src="detail.videoUrl" loop="true" controls preload="none" x5-video-player-type="h5" x5-video-player-fullscreen="true">
        您的浏览器不支持 video 标签
      </video>
    </div> -->
    <!--配送方式修改-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="distributionShow" title="配送方式">
      <div class="content distribution_pop">
        <div class="distribution_pop_main pop_height">
          <template v-if="psDeliveryList.length > 0 && isPs">
            <p class="f14_rem gary_3 fb">支持配送的区域：</p>
            <p class="f12_rem gary_3" v-for="shopDelivery in psDeliveryList" :key="shopDelivery.deliveryId">
              <span>{{ shopDelivery.allName }}</span>
            </p>
          </template>
          <template v-if="ztDeliveryList.length > 0 && isZt">
            <div class="box10"></div>
            <p class="f14_rem gary_3 fb">支持自提的地址：</p>
            <p class="f12_rem gary_3" v-for="(shopDelivery, index) in ztDeliveryList" :key="index">
              <span>{{ shopDelivery.allName }}</span>
            </p>
          </template>
        </div>
      </div>
    </van-action-sheet>
    <!--    &lt;!&ndash;拼团规则&ndash;&gt;
    &lt;!&ndash;eslint-disable-next-line&ndash;&gt;
    <van-action-sheet v-model:show="ptShow" title="拼团规则" :closeable="false">
      <div class="content">
        <div class="z_shipping b_white gray_3 height pop_height" id="ptgz">
          <p class="f14 mui-text-center gray_3 fb">拼团规则</p>
          <div class="box20"></div>
          <div class="height260 pad20_r">
            <p class="f14  gray_3 fb">1、拼团操作流程</p>
            <p class="line-height20 gray_3 f12">① 买家点击发起拼团，填写购买数量，提交订单并完成支付，拼团即发起成功
            </p>
            <p class="line-height20 gray_3 f12">② 为了更快地成团，发起成功后，可把拼团信息分享给其他人邀请他人一起参与；
            </p>
            <p class="line-height20 gray_3 f12">③ 当所有的参与人的购买数量达到最小成团量后，该拼团即成功，即可等待卖家发货
            </p>
            <p class="line-height20 gray_3 f12">④ 买家也可直接参与别人已经发起的拼团，具体流程同上</p>
            <div class="box10"></div>
            <p class="f12 gray_3 fb">2、拼团注意事项</p>
            <p class="line-height20 gray_3 f12">① 最小成团量：即每个拼团达标的最小数量，活动结束前当参团人的购买数量超过最小成团量时，拼团即达标；否则，拼团失败；
            </p>
            <p class="line-height20 gray_3 f12">② 单人最大购买量：每人能够以拼团价购买的最大数量
            </p>
          </div>
          <div class="box10"></div>
          &lt;!&ndash;          <p class="z_sure">
                      <button class="mui-btn mui-btn-block f14 white mui-text-center">确定</button>
                    </p>&ndash;&gt;
        </div>
      </div>
    </van-action-sheet>-->

    <!--优惠券-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="couponShow" title="优惠">
      <div class="content cart_coupon_pop">
        <div class="cart_coupon_wrap pop_height">
          <div class="discounts_vip" v-if="detail.isVip == 1 || (detail.isVip == 0 && detail.vipMoney)">
            <div class="flex_align_center">
              <img class="h16" v-if="detail.goodsPriceMemberLevel === '1'"
                src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
              <img class="h16" v-else-if="detail.goodsPriceMemberLevel === '2'"
                src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
              <img class="h16" v-else-if="detail.goodsPriceMemberLevel === '3'"
                src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
              <img class="h16" v-else-if="detail.goodsPriceMemberLevel === '4'"
                src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
              <img class="h16" v-else-if="detail.goodsPriceMemberLevel === '5'"
                src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
              <span class="f18_rem c_f7c36f" v-else>VIP</span>
              <span class="f11_rem white pad15_l" v-if="detail.vipRebateCouponNum !== 0">预计返现金券{{
                detail.vipRebateCouponNum }}张</span>
            </div>
            <a class="open_discounts_vip" v-if="memberVip.id && detail.goodsPriceMemberLevel === '1'"
              :href="`/mob/goods/detail/${detail.vipGoodsId}`">立即续费</a>
            <a class="open_discounts_vip" v-if="!memberVip.id" href="/mob/memberInfo/toVipIntroduce">开通VIP</a>
          </div>

          <div v-if="fetchCoupon.length > 0">
            <p class="gray_2 mar10_b">可领取的优惠券</p>
            <ul>
              <template v-for="coupon in fetchCoupon">
                <li class="clear" :key="coupon.id">
                  <div class="mui-pull-left coupon_left t_center">
                    <p class="white">
                      ￥<span class="f26_rem">{{ coupon.regVal }}</span>
                    </p>
                    <p class="white f11_rem">满{{ coupon.regKey }}可用</p>
                  </div>
                  <div class="mui-pull-left coupon_right">
                    <div class="mui-pull-left">
                      <p class="f12_rem gray_2 shop_coupon_overflow">{{ coupon.couponTypeName }}</p>
                      <div class="box20"></div>
                      <p class="f11_rem gray_9">
                        {{ coupon.useStartTimeStr }} - {{ coupon.useEndTimeStr }}
                      </p>
                    </div>
                    <span class="white b_red get_coupon mui-pull-right f12_rem t_center" @click="getCoupon(coupon)"
                      v-if="coupon.surplusNum !== 0">立即领取</span>
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <div v-if="goodsCoupon.length > 0">
            <p class="gray_2 mar10_b">本品可用的优惠券</p>
            <ul>
              <template v-for="(coupon, index) in goodsCoupon">
                <li class="clear" :key="index">
                  <div class="mui-pull-left coupon_left t_center">
                    <p class="white">
                      ￥<span class="f26_rem">{{ coupon.regVal }}</span>
                    </p>
                    <p class="white f11_rem">满{{ coupon.regKey }}可用</p>
                  </div>
                  <div class="mui-pull-left coupon_right">
                    <div class="mui-pull-left">
                      <p class="f12_rem gray_2 shop_coupon_overflow">{{ coupon.couponTypeName }}</p>
                      <div class="box20"></div>
                      <p class="f11_rem gray_9">
                        {{ coupon.useStartTimeStr }} - {{ coupon.useEndTimeStr }}
                      </p>
                    </div>
                    <span class="white b_red get_coupon mui-pull-right f12_rem t_center"
                      @click="getCouponTo(coupon)">立即使用</span>
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <div v-if="receivedCoupon.length > 0">
            <p class="gray_2 mar10_b">已领取的优惠券</p>
            <ul>
              <template v-for="(coupon, index) in receivedCoupon">
                <li class="clear" :key="index">
                  <div class="mui-pull-left coupon_left t_center">
                    <p class="white">
                      ￥<span class="f26_rem">{{ coupon.regVal }}</span>
                    </p>
                    <p class="white f11_rem">满{{ coupon.regKey }}可用</p>
                  </div>
                  <div class="mui-pull-left coupon_right">
                    <div class="mui-pull-left">
                      <p class="f12_rem gray_2 shop_coupon_overflow">{{ coupon.couponTypeName }}</p>
                      <div class="box20"></div>
                      <p class="f11_rem gray_9">
                        {{ coupon.useStartTimeStr }} - {{ coupon.useEndTimeStr }}
                      </p>
                    </div>
                    <span class="white b_red get_coupon mui-pull-right f12_rem t_center"
                      @click="getCouponTo(coupon)">立即使用</span>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--生成海报-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="posterShow" class="poster_pop_wrap">
      <div class="poster_pop">
        <img :src="billImgUrl" alt="" />
      </div>
      <!--v-if="saveBillBtn"-->
      <div class="saveBillBtn" v-if="saveBillBtn" @click="saveBill">保存图片</div>
    </van-popup>

    <!--地址选择-->
    <!--eslint-disable-next-line-->
    <!--    <van-popup v-model:show="addListShow"
               position="bottom"
               :style="{ height: '100%' }">
      <van-address-list
        v-model="chosenAddressId"
        :list="addressList"
        default-tag-text="默认"
        @add="addressEdit({})"
        @select="addressSelect"
      />
    </van-popup>-->
    <!--地址编辑-->
    <!--eslint-disable-next-line-->
    <!--    <van-popup v-model:show="addEditShow"
               position="bottom"
               :style="{ height: '100%' }">
      <van-address-edit
        :area-list="areaList"
        show-delete
        show-set-default
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        :address-info="addressInfo"
        tel-maxlength="11"
        :tel-validator="validator"
        @save="addressSave"
        @delete="addEditShow = false"
      />
    </van-popup>-->
    <!--运费选择-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="freightShow" closeable round :safe-area-inset-bottom="true" position="bottom"
      :style="{ height: '40%' }">
      <div class="freight_pop">
        <h2>配送方式</h2>
        <van-radio-group v-model="freight.tId">
          <van-radio :name="item.tId" v-for="item in freightList" :key="item.tId" @click="freightCheck(item)">
            <div>
              <p class="gray_3">{{ item.transModeCn }} {{ item.freightMoney }}元/吨</p>
              <p class="f12_rem">具体运费根据购买数量决定</p>
            </div>
          </van-radio>
        </van-radio-group>
      </div>
    </van-popup>
    <!--vip返券说明-->
    <!--eslint-disable-next-line-->
    <van-dialog v-model:show="vipDeclareShow" confirm-button-text="关闭" :close-on-click-overlay="true">
      <div class="van-dialog__message">
        该数量为普通VIP最高返券数量，实际数量将根据VIP类型及实际付款金额进行返券，请以下单后订单详情页及实际返券数量为准。每张现金券面值1元，购买货品时可进行抵扣，且VIP价格不与其他优惠同时享用。
      </div>
    </van-dialog>
    <!--优惠信息-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="discountsShow" title="优惠">
      <div class="content discounts_pop">
        <div class="discounts_pop_main pop_height">
          <ul>
            <li class="clear mar10_b" v-if="detail.promotion && detail.promotion.giftGoodsId && detail.isVip == 0">
              <span class="float-left mar15_r discounts_pop_icon">买赠</span>
              <div class="float-left">
                <p class="mar15_r mar15_b gray_3">{{ detail.promotion.promotionName }}</p>
                <div class="clear">
                  <span class="float-left mar15_r gray_3">赠</span>
                  <div class="float-left">
                    <p class="mar15_b gray_6 discounts_pop_item"
                      @click="toGoodsDetail(this.detail.promotion.giftGoodsId)">
                      <span class="max_w260 ellipsis inlineblock">{{
                        detail.promotion.giftGoodsName
                        }}</span>
                      <span class="ver_top"> x1</span>
                      <img src="./images/good_operation_back.png" alt="" />
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </van-action-sheet>
    <!--集采规则信息-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="collectShow" title="集采规则">
      <div class="content collect_pop">
        <div class="collect_pop_main pop_height">
          <p class="gray_3 f14_rem fb">最小起订量</p>
          <p class="gray_6 f12_rem">
            单个买家的购买数量必须大于等于最小起订数量，才能享受集采价优惠。
          </p>
          <p class="gray_3 f14_rem fb">集采进度</p>
          <p class="gray_6 f12_rem">集采进度=（所有买家已经购买的数量/活动总量）*100%</p>
          <p class="gray_3 f14_rem fb">保证金规则介绍</p>
          <p class="gray_6 f12_rem">
            ①为保证交易双方合法权益，集采货品交易需要冻结买卖双方一定比例的保证金，如果一方违约，则扣除该方的保证金补偿给对方
          </p>
          <p class="gray_6 f12_rem">②卖家在发布集采活动时，保证金已冻结</p>
          <p class="gray_6 f12_rem">
            ③买家提交订单时冻结保证金，冻结保证金的金额=集采价*购买数量*保证金比例
          </p>
          <p class="gray_6 f12_rem">
            ④提交订单后，卖家先签署电子合同，签署完成后再由买家进行签署，买家签署成功即可解冻双方保证金
          </p>
        </div>
      </div>
    </van-action-sheet>
    <!--拼团规则信息-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="groupShow" title="拼团规则">
      <div class="content collect_pop">
        <div class="collect_pop_main pop_height">
          <p class="gray_3 f14_rem fb">1、拼团操作流程</p>
          <p class="gray_6 f12_rem">
            ① 买家点击发起拼团，填写购买数量，提交订单并完成支付，拼团即发起成功
          </p>
          <p class="gray_6 f12_rem">
            ② 为了更快地成团，发起成功后，可把拼团信息分享给其他人邀请他人一起参与；
          </p>
          <p class="gray_6 f12_rem">
            ③ 当所有的参与人的购买数量达到最小成团量后，该拼团即成功，即可等待卖家发货
          </p>
          <p class="gray_6 f12_rem">④ 买家也可直接参与别人已经发起的拼团，具体流程同上</p>
          <p class="gray_3 f14_rem fb">2、拼团注意事项</p>
          <p class="gray_6 f12_rem">
            ①
            最小成团量：即每个拼团达标的最小数量，活动结束前当参团人的购买数量超过最小成团量时，拼团即达标；否则，拼团失败；
          </p>
          <p class="gray_6 f12_rem">② 单人最大购买量：每人能够以拼团价购买的最大数量</p>
        </div>
      </div>
    </van-action-sheet>

    <!--加购物车选择规则弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addCartShow" :safe-area-inset-bottom="true" closeable round position="bottom">
      <div class="addCart_pop">
        <div class="addCart_pop_main flex flex-column">
          <div class="clear addCart_good_info">
            <img class="float-left good_img" :src="detail.imgUrl1" alt="" />
            <div v-if="detail.commonLaddersPrice" class="float-left addCart_good_main" style="max-width: 200px;">
              <div class="mar10-b gray3 fb f36">{{ detail.spuName }}</div>
              <div class="flex">
                <div class="f11 gray9 text-center pad10-lr ladders-price-unit">
                  {{ detail.spec }}
                </div>
              </div>
            </div>
            <div v-else class="float-left addCart_good_main">
              <p class="red pad10_b" v-if="detail.goodsPrice.sellFactPrice">
                <template v-if="memberVip.memberType">
                  <img class="h25 mar5-r" v-if="detail.goodsPriceMemberLevel === '1'"
                    src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
                  <img class="h25 mar5-r" v-if="detail.goodsPriceMemberLevel === '2'"
                    src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
                  <img class="h25 mar5-r" v-if="detail.goodsPriceMemberLevel === '3'"
                    src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
                  <img class="h25 mar5-r" v-if="detail.goodsPriceMemberLevel === '4'"
                    src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
                  <img class="h25 mar5-r" v-if="detail.goodsPriceMemberLevel === '5'"
                    src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
                </template>
                ¥<span class="f20_rem fb">{{ detail.goodsPrice.sellFactPrice }}</span>
              </p>
              <p class="gray_6 f20_rem pad10_b" v-else><span>暂无价格</span></p>
              <p class="gray_9 f12_rem pad10_b">
                库存数量：{{ detail.currQuantity }}{{ detail.mUnitCn }}
              </p>
              <p class="f12_rem" v-if="specification.specType === 1">
                <span class="gray_9 pad5-r">已选</span>
                <span class="pad5-l gray3" v-for="(sku, index) in specification.skuSpecsList" :key="index">{{ sku
                  }}</span>
              </p>
            </div>
          </div>
          <!-- 阶梯价 -->
          <template v-if="
              detail.goodsPrice &&
                detail.goodsPrice.commonLaddersPrice &&
                detail.goodsPrice.commonLaddersPrice.goodsPriceList &&
                detail.goodsPrice.commonLaddersPrice.goodsPriceList.length
            ">
            <div v-if="detail.commonLaddersPrice" class="relative lh1 bg-fa radius8 common-ladders-price">
              <div class="absolute radius10 overflow progress">
                <div class="h100-full radius10 progress-bar" :style="{ width: progressBar }"></div>
              </div>
              <div class="flex relative text-center flex-item1 justify-between z-index2">
                <div class="item" v-for="(item, index) in detail.goodsPrice.commonLaddersPrice.goodsPriceList"
                  :key="item.level" :class="{ active: index === laddersPriceIndex }">
                  <div class="flex justify-center icon-wrap mar14-b">
                    <div class="flex radius100 pad7-l pad10-r icon">
                      <template v-if="item.unitRatioStr">
                        <div class="fb f13 gray6">¥{{ priceSplit2(item.unitRatioStr)[0] }}</div>
                        <div class="f10 gray9 mar2-l">
                          元{{ priceSplit2(item.unitRatioStr)[1] }}
                        </div>
                      </template>
                      <div class="fb f13 gray6" v-else>¥{{ item.price }}</div>
                    </div>
                  </div>
                  <div v-if="item.unitRatioStr" class="price gray3 pad2-lr fb f15 mar4-b">
                    ¥{{ item.price }}
                  </div>
                  <div class="gray9 pad2-lr fb f12">
                    <template v-if="index == detail.goodsPrice.commonLaddersPrice.goodsPriceList.length - 1">
                      ≥{{ item.minQuantity }}
                    </template>
                    <template v-else>
                      <template v-if="item.minQuantity == item.maxQuantity">
                        {{ item.minQuantity }}
                      </template>
                      <template v-else>
                        {{ item.minQuantity }}~{{ item.maxQuantity }}
                      </template>
                    </template>
                    {{ detail.mUnitCn }}
                  </div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="f12 fb mar10-t pad15-lr ladders-price-tips" v-if="detail.commonLaddersPrice">
                按照购买商品总数量计算当前阶梯价
              </div>
              <div class="bg-white fb pad15-t flex flex-item1 justify-between ladders-price">
                <div v-for="(item, index) in detail.goodsPrice.commonLaddersPrice.goodsPriceList"
                  class="item flex flex-column justify-center items-center" :key="item.level"
                  :class="{ active: index === laddersPriceIndex }" @click="laddersPriceChange(item, index)">
                  <div class="active-icon f20" v-if="item.unitRatioStr || index === laddersPriceIndex">
                    <div v-if="!item.unitRatioStr && index === laddersPriceIndex" class="pad4-r">
                      当前价
                    </div>
                    <div v-else>{{ item.unitRatioStr }}</div>
                  </div>
                  <div class="flex justify-center items-baseline mar5-t">
                    <div class="f15">¥</div>
                    <div class="f20">{{ priceSplit(item.price)[0] }}</div>
                    <div class="f15">{{ priceSplit(item.price)[1] }}</div>
                  </div>
                  <div class="f13 gray3">
                    <template v-if="index == detail.goodsPrice.commonLaddersPrice.goodsPriceList.length - 1">
                      ≥{{ item.minQuantity }}
                    </template>
                    <template v-else>
                      <template v-if="item.minQuantity == item.maxQuantity">
                        {{ item.minQuantity }}
                      </template>
                      <template v-else>
                        {{ item.minQuantity }}~{{ item.maxQuantity }}
                      </template>
                    </template>
                    {{ detail.mUnitCn }}
                  </div>
                </div>
              </div>
            </template>
          </template>
          <!-- 多规格 -->
          <div class="ladders-price-spce mar20-t" v-if="detail.commonLaddersPrice">
            <div class="gray3 f18 fb">
              {{ detail.specialList && detail.specialList[0] && detail.specialList[0].specType }}
            </div>
            <div v-for="(spce, spceIndex) in detail.specGroupInfo" class="mar15-t flex items-center mar5-b"
              :key="spceIndex">
              <div class="flex-auto lh1">
                <div class="f15 gray3 fb">
                  {{ spce.specGroupName }}
                </div>
                <div class="flex f12 mar5-t lh1">
                  <div class="yellow mar10-r" v-if="Number(spce.skuResList[0].minOrderQuantity)">
                    {{ spce.skuResList[0].minOrderQuantity }}{{ spce.skuResList[0].mUnitCn }}起订
                  </div>
                  <div v-if="
                      spce.quantity && spce.skuResList[0].unitRatio && spce.skuResList[0].sUnitCn
                    ">
                    共{{
                    Number(
                    (Number(spce.quantity) * Number(spce.skuResList[0].unitRatio)).toFixed(6)
                    )
                    }}{{ spce.skuResList[0].sUnitCn }}
                  </div>
                </div>
              </div>
              <div class="flex-shrink overflow flex ladders-special-input">
                <van-stepper v-model="spce.quantity" input-width="70px" button-size="30px" :class="{
                    'minus-disabled':
                      Number(spce.skuResList[0].minOrderQuantity) &&
                      spce.skuResList[0].minOrderQuantity > 1 &&
                      spce.quantity <= spce.skuResList[0].minOrderQuantity
                  }" :min="0" :max="spce.skuResList[0].currQuantity" :decimal-length="spce.skuResList[0].goodsDigit"
                  @blur="formatNum2($event, spce)" @plus="stepperChange2Plus(spce)"
                  @change="stepperChange2($event, spce)" />
              </div>
            </div>
            <div class="pad15"></div>
          </div>
          <template v-else>
            <div class="pad5-t flex-auto overflow-auto" v-if="specification.specType === 1">
              <div v-for="(item, index) in specification.specialList" :key="index">
                <p class="gray_3 fb f14_rem addCart_specification_head">{{ item.specType }}</p>
                <ul class="clear">
                  <li v-for="(spec, index1) in item.specValList" :key="index1" :class="{
                      addCart_specification_active: spec === specification.skuSpecsList[index]
                    }" @click="skuClick(spec, index)">
                    {{ spec }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="pad5-t" v-else>
              <p class="gray_3 fb f14_rem addCart_specification_head">规格</p>
              <ul class="clear">
                <li class="addCart_specification_active">{{ detail.spec }}</li>
              </ul>
            </div>
            <div class="flex mar30_t mar15_b" v-if="detail.goodsPrice.sellFactPrice">
              <span class="gray_3 fb f14_rem flex-auto">数量</span>
              <div>
                <van-stepper v-model="addCartNum" input-width="140px" button-size="30px" :class="{
                    'minus-disabled':
                      detail.minOrderQuantity &&
                      detail.minOrderQuantity > 1 &&
                      addCartNum <= detail.minOrderQuantity
                  }" :max="detail.currQuantity" :decimal-length="detail.goodsDigit" @blur="formatNum"
                  @change="stepperChange" />
                <div class="gray9 f10 pad5-t text-center" v-if="detail.minOrderQuantity && detail.minOrderQuantity > 0">
                  {{ detail.minOrderQuantity }}{{ detail.mUnitCn }}起订
                </div>
              </div>
            </div>
          </template>
          <template v-if="addCartType === 1">
            <div class="addCart_pop_btn" v-if="
                detail.promotion &&
                  detail.promotion.isGroupPurchase == 1 &&
                  detail.promotion.isGroupTeam == 0 &&
                  detail.promotion.marginStatus == 1
              ">
              <span class="b_fff0f2 red mar15_r" @click="buy(2)">市场价购买</span>
              <span class="b_red white" @click="buy(3)">集采价购买</span>
            </div>
            <div class="addCart_pop_btn" v-else-if="
                detail.promotion &&
                  detail.promotion.isGroupPurchase == 1 &&
                  detail.promotion.isGroupTeam == 1 &&
                  detail.promotion.marginStatus == 1
              ">
              <!-- 集采-拼团 -->
              <span class="b_fff0f2 red mar15_r" @click="buy(2)">市场价购买</span>
              <span class="b_red white" @click="buy(3)">发起拼团</span>
            </div>
            <div class="addCart_pop_btn" v-else>
              <span class="b_fff0f2 red mar15_r" v-if="detail.goodsPrice.sellFactPrice > 0" @click="buy(1)">加入进货车</span>
              <span class="b_red white" v-if="detail.goodsPrice.sellFactPrice > 0" @click="buy(0)">
                {{
                detail.minOrderQuantity > 1
                ? `${detail.minOrderQuantity}${detail.mUnitCn}起购`
                : "立即购买"
                }}
              </span>
              <span class="b_red white"
                v-if="detail.goodsPrice.sellFactPrice !== null && !detail.goodsPrice.sellFactPrice"
                @click="buy(0)">点击询价</span>
            </div>
          </template>
          <template v-else>
            <div class="addCart_pop_btn">
              <p v-if="detail.commonLaddersPrice" class="b_red white" @click="buy(source)">
                {{ commonLaddersPriceConfirmText }}
              </p>
              <p v-else class="b_red white" @click="buy(source)">
                {{
                detail.sUnitCn && detail.unitRatio
                ? `确定(共${Number(
                (Number(addCartNum) * Number(detail.unitRatio)).toFixed(6)
                )}${detail.sUnitCn})`
                : "确定"
                }}
              </p>
            </div>
          </template>
        </div>
      </div>
    </van-popup>
    <!--地址选择-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="addChooseShow" :safe-area-inset-bottom="false" title="配送至">
      <div class="content addChoose_pop">
        <div class="addChoose_pop_main pop_height">
          <ul>
            <template v-for="address of addressList">
              <li :class="{ addChoose_active: address.deliveryId === chosenAddressId }" v-if="address.deliveryId"
                :key="address.deliveryId" @click="addressSelect(address)">
                <p class="gray_3 f14_rem">
                  <span class="fb mar15_r">{{ address.name }}</span>
                  <span>{{ address.tel }}</span>
                </p>
                <p class="gray_3 f12_rem">{{ address.addr }}</p>
              </li>
            </template>
          </ul>
          <div class="addChoose_pop_btn" @click="addAddressDialog">新增收货地址</div>
          <!--@click="addAddressShow = true"-->
        </div>
      </div>
    </van-action-sheet>
    <!--新增收货地址-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addAddressShow" position="bottom" :style="{ height: '100%' }">
      <div class="addAddress_pop">
        <!--        <div class="addAddress_pop_head">
          <van-icon name="arrow-left" color="#333" size="18px" />
          <span>新增收货地址</span>
          <van-icon name="cross" color="#333" size="18px" />
        </div>-->
        <div class="addAddress_pop_main">
          <van-field v-model="addAddress.name" label="联系人" placeholder="您的姓名" />
          <van-field v-model="addAddress.tel" type="tel" maxlength="11" label="联系电话" placeholder="您的手机" />
          <van-field v-model="addAddress.areaName" label="配送区域" placeholder="点击选择配送区域" readonly
            @click="addAreaShow = true" />
          <van-field v-model="addAddress.addr" label="详细地址" placeholder="请填写您的详细地址" />
          <van-cell center title="默认地址">
            <template #right-icon>
              <van-switch v-model="addAddress.isdefault" size="20px" active-color="#ff0023" inactive-color="#ddd" />
            </template>
          </van-cell>
        </div>
        <div class="addAddress_pop_btn">
          <span class="b_red white bor_red" @click="addressSave">确定</span>
          <span class="bor_ddd b_white gray_3 " @click="addAddressShow = false">返回</span>
        </div>
      </div>
    </van-popup>
    <!--新增收货地址地区选择-->
    <!--https://vant-contrib.gitee.io/vant/v3/#/zh-CN/cascader-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addAreaShow" :safe-area-inset-bottom="true" round position="bottom">
      <van-cascader v-model="addAddress.areaId" title="请选择所在地区" :options="options" @change="areaChange"
        @finish="areaSelect" :field-names="fieldNames" @close="addAreaShow = false" />
    </van-popup>
    <!--农信优选弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="nxyxShow" round>
      <div class="nxyx_pop">
        <div class="super">
          <div class="super_title">选择农信优选</div>
          <div class="supers">
            <div class="super_item">
              <img src="./images/yx1.jpg" alt="" />
              <div>省钱</div>
            </div>
            <div class="super_item">
              <img src="./images/yx2.jpg" alt="" />
              <div>省心</div>
            </div>
            <div class="super_item">
              <img src="./images/yx3.jpg" alt="" />
              <div>省时</div>
            </div>
            <div class="super_item">
              <img src="./images/yx4.jpg" alt="" />
              <div>省事</div>
            </div>
          </div>
        </div>
        <div class="what_wp">
          <div class="what">何为农信优选？</div>
          <div class="super_wp">
            <div>我们根植农牧行业一线，深挖终端真实需求</div>
            <div>深入产品原产地，用专业的审核标准</div>
            <div>从源头把控产品生产环节</div>
            <div>力求为农牧从业者甄选最优质的产品</div>
            <div>提供7*12小时专属客服</div>
            <div>并通过线下运营网点提供售后配送服务</div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 套餐 -->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="packageShow" position="bottom" round closeable>
      <div class="safe-pad-bottom gray3 f15 bg-white">
        <div class="text-center pad20-b pad15-t gray3 f16 fb">套餐商品</div>
        <div class="pad20-lr">
          <div class="pad20-b">共{{ packageSkuList.length }}{{ detail.mUnitCn }}商品</div>
          <template v-for="packageSku in packageSkuList">
            <div class="flex mar15-b">
              <div class="wh100 flex-shrink mar15-r">
                <img class="w100-full radius10 h100-full" :src="`${packageSku.picUrl}?imageView2/1/w/200/h/200`" />
              </div>
              <div class="flex flex-auto pad5-tb flex-column justify-between">
                <div class="ellipsis_two">
                  {{ packageSku.name }}
                </div>
                <div class="f13">
                  设置价<span class="pad5-l red">￥{{ packageSku.additionalGoodsPrice }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script src="./jweixin-1.4.0.js"></script>
<script>
  import { mapState } from "vuex";
  import { Toast } from "vant";
  import "vue-draggable-resizable/dist/VueDraggableResizable.css";
  import DraggableResizable from "vue-draggable-resizable";
  import Menu from "@/components/menu";
  import EvaluateItemItem from "@/components/evaluateItem";

  import WeiXinShare from "../../assets/js/weiXinShare";
  // import cityData3 from '../../assets/js/city.data-3';
  import common from "../../assets/js/common";
  import { priceSplit, contactService } from "@/utils/utils";
  import {
    getGoodsEvaluateList,
    getGoodsEvaluateCollect,
    getPackageSkuList,
    getBpSkuIdList,
    getSkuInfo,
    selBp
  } from "@/api/app";

  export default {
    components: {
      Menu,
      DraggableResizable,
      EvaluateItemItem
    },

    data() {
      return {
        goodsId: "",
        isGoodCollect: false,
        isShopCollect: false,
        distributionShow: false,
        ptShow: false,
        distributionName: "卖家配送",
        current: 0,
        imgSize: 1,
        time: 300 * 60 * 60 * 1000,
        packageShow: false,
        detail: {
          goodsList: [],
          goodsFreight: {},
          goodsShop: {},
          goodsComment: {},
          goodsShopDelivery: {},
          couponRule: {},
          shopDtlEntity: {},
          goodsContractVoList: [],
          memberInfo: {},
          shopEntity: {},
          goodsPrice: { sellFactPrice: null },
          promotion: {},
          groupTeamList: [],
          goodsDyDtlList: []
        },
        deliveryVO: {
          memberDeliveryEntity: {},
          memberDeliveryList: []
        },
        adList: [],
        evaluate: {},
        detailContent: {},
        loadGoods: {}, // 优惠券 ,货品扩展属性等
        goodsCouponName: "",
        fetchCoupon: [], // 可领取的优惠券
        goodsCoupon: [], // 本品可用的优惠券
        receivedCoupon: [], // 已领取的优惠券
        freight: {}, // 运费
        freightList: [], // 运费模板
        countNum: 1,
        billImgUrl: "", // 海报url
        isShare: true, // 是否展示分享
        isShowShare: false, // 是否展示分享蒙层
        isZt: false, // 是否自提
        isPs: false, // 是否配送
        addrType: 0, // 选择地址入口 0:选择入口 1集采报名
        video_wrap: false,
        couponShow: false, // 优惠券弹框显示
        posterShow: false, // 生成海报弹框显示
        addListShow: false, // 是否显示地址列表
        addEditShow: false, // 是否显示地址编辑
        saveBillBtn: false,
        chosenAddressId: 0, // 默认地址的id
        addressList: [
          // 我的地址列表
        ],
        disabledList: [
          // 超出范围地址
        ],
        addressInfo: {}, // 编辑地址的地址信息
        // areaList: cityData, // 省市县的数据
        areaList: {}, // 省市县的数据
        searchResult: [], // 搜索详细地址联想的地址
        freightShow: false, // 运费弹框
        vipDeclareShow: false, // vip说明弹框
        detailHtml: "", // 商品详情
        countCart: 0, // 购物车数量
        discountsShow: false, // 是否显示优惠信息
        collectShow: false, // 是否显示集采规则信息
        groupShow: false, // 是否显示拼团规则信息
        addCartShow: false, // 是否显示加购物车选择规则弹框
        source: 1, // 配送方式、加入购物车、立即购买标识
        addChooseShow: false, // 是否显示地址列表
        addAddressShow: false, // 是否显示新增收货地址
        addAreaShow: false, // 是否显示新增收货地址省市区选择
        addCartNum: 1, // 加入进货车的数量
        addCartType: 1, // 1已选
        // goodsPrice: "",
        addAddress: {
          name: "",
          tel: "",
          areaId: "",
          addr: "",
          isdefault: true,
          areaName: ""
        },
        fieldNames: {
          text: "name",
          value: "id",
          children: "children"
        },
        options: [],
        areaIndex: [],
        nxin_live_url: "",
        comboGoodsName: "",
        ztDeliveryList: [],
        psDeliveryList: [],
        video: {
          // 视频播放相关参数
          url: "",
          cover: "",
          muted: false,
          loop: false,
          preload: "none",
          volume: 1,
          autoplay: true,
          playsinline: true
        },
        isShowVideo: true, // 是否显示视频播放
        nxyxShow: false, // 是否显示农信直选介绍
        isShowFoot: false,
        // 多规格数据
        specification: {
          specType: 0,
          specialList: [],
          skuSpecsList: []
        },
        scrollTop: 0,
        memberVip: {}, // vip信息
        draggableX: 0,
        draggableY: 170,
        draggableVisible: true,
        draggableW: 80,
        draggableH: 140,
        videoWXFirst: false,
        VUE_APP_SC: process.env.VUE_APP_SC,
        goodsEvaluateList: [], // 商品评价列表
        goodsEvaluateCollect: {}, // 商品评价概况
        packageSkuList: [], // 套餐商品
        priceSplit, // 价格分割
        laddersPriceIndex: -1, // 当前阶梯价索引
        specGroupCheckedName: "",
        commonLaddersPriceConfirmText: ""
      };
    },
    computed: mapState({
      userInfo: state => state.app.userInfo,
      progressBar() {
        const { detail, laddersPriceIndex } = this;
        if (detail.commonLaddersPrice) {
          if (laddersPriceIndex == -1) {
            return 0;
          }
          const { goodsPriceList } = detail.commonLaddersPrice;
          if (laddersPriceIndex == 0 && goodsPriceList.length == 2) {
            return "60%";
          }
          if (laddersPriceIndex == 0 && goodsPriceList.length == 3) {
            return "10%";
          }
          if (laddersPriceIndex == 1 && goodsPriceList.length == 3) {
            return "60%";
          }
          return "100%";
        }
        return "100%";
      }
    }),
    watch: {
      "detail.specGroupInfo": {
        deep: true,
        immediate: true,
        handler(data) {
          const { detail } = this;
          if (!data || !data.length) {
            return;
          }

          const dataArr = [];

          const quantityTotal = data.reduce((total, item) => {
            if (item.quantity) {
              dataArr.push(item.specGroupName);
              return total + Number(item.quantity);
            }
            return total;
          }, 0);

          this.specGroupCheckedName = dataArr.join("、");
          if (quantityTotal) {
            const goodsPriceList = JSON.parse(
              JSON.stringify(this.detail.commonLaddersPrice.goodsPriceList)
            );
            const arr = goodsPriceList
              .reverse()
              .filter(item => quantityTotal >= Number(item.minQuantity))[0];
            if (arr) {
              this.laddersPriceIndex = arr.level - 1;
            } else {
              this.laddersPriceIndex = -1;
            }
            this.commonLaddersPriceConfirmText = Number(this.detail.unitRatio)
              ? `确定(共${Number(
                (Number(quantityTotal) * Number(this.detail.unitRatio)).toFixed(6)
              )}${detail.sUnitCn})`
              : "确定";
          } else {
            this.laddersPriceIndex = -1;
            this.commonLaddersPriceConfirmText = "确定";
          }
        }
      }
    },
    async created() {
      console.log("goodDetails=====", this.userInfo);
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      this.goodsId = this.$route.params.goodsId;
      const shareBoId = this.$route.query.shareBoId || 0;
      const { data } = await selBp({
        goodsId: this.goodsId
      });
      if (data) {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //eslint-disable-line
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              // 小程序
              wx.miniProgram.redirectTo({
                url: `/activity518/activity518?spuId=${data}&shareBoId=${shareBoId}`
              });
            } else {
              window.location.href = `${process.env.VUE_APP_APP
                }vm2/activity518/activity518?back=-2&spuId=${data}&shareBoId=${shareBoId}`;
            }
          });
        } else {
          window.location.href = `${process.env.VUE_APP_APP
            }vm2/activity518/activity518?back=-2&spuId=${data}&shareBoId=${shareBoId}`;
        }
      }
      if (!common.isMobile()) {
        window.location.href = `${process.env.VUE_APP_APP}goods/queryGoodsDetailInfo/${this.goodsId
          }?shareBoId=${shareBoId}`;
        return;
      }
      this.getAreas(0, 0);
      this.getGoodsDetail(this.$route.query);
      this.selMemberVip();

      var isAndroidWechat =
        /android/i.test(navigator.userAgent) && /micromessenger/i.test(navigator.userAgent);
      if (isAndroidWechat) {
        this.videoWXFirst = true;
      }
    },
    mounted() {
      // const { videoPlayer } = $refs;
      // document.getElementById("video").play();
      this.draggableX = window.screen.width - 100;
      this.$refs.goodDetail.scrollTo({ top: 0, behavior: "smooth" });
      console.log("goodDetailsMounted=====", this.userInfo);
      this.$store
        .dispatch("goodDetails/goodDetails/getLiveList", { goodsId: this.goodsId })
        .then(data => {
          console.info(data);
          if (data !== null && data.data !== null && data.data !== "") {
            document.getElementsByClassName("nxin_live_wrap")[0].classList.add("block", "sildin");
            this.nxin_live_url = data.data.shareContent;
          }
        });
      window.addEventListener("scroll", this.scrollToTop);

      //必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          document.getElementById("video").play();
        },
        false
      );
    },
    // beforeRouteLeave(to, from, next) {
    //   this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   next();
    // },
    // 进入该页面时，用之前保存的滚动位置赋值
    // beforeRouteEnter(to, from, next) {
    //   next(vm => {
    //     console.log("scrollTop", vm.scrollTop);
    //     document.body.scrollTop = vm.scrollTop;
    //   });
    // },
    methods: {
      contactService() {
        contactService();
      },
      laddersPriceChange(data, index) {
        if (this.detail.commonLaddersPrice) {
          return;
        }
        if (this.laddersPriceIndex !== index) {
          this.laddersPriceIndex = index;
          this.addCartNum = data.minQuantity;
        }
      },
      stepperChange(value) {
        console.log("stepperChange");
        const { detail } = this;
        const minOrderQuantity = Number(detail.minOrderQuantity);
        // if (value && Number(value) < minOrderQuantity) {
        //   this.$nextTick(() => {
        //     this.addCartNum = minOrderQuantity;
        //   });
        // }
        if (
          detail.goodsPrice &&
          detail.goodsPrice.commonLaddersPrice &&
          detail.goodsPrice.commonLaddersPrice.goodsPriceList &&
          detail.goodsPrice.commonLaddersPrice.goodsPriceList.length
        ) {
          this.$nextTick(() => {
            let { goodsPriceList } = JSON.parse(JSON.stringify(detail.goodsPrice.commonLaddersPrice));
            goodsPriceList = goodsPriceList.reverse();
            const arr = goodsPriceList.filter(item => Number(value) >= Number(item.minQuantity))[0];
            if (arr) {
              this.laddersPriceIndex = arr.level - 1;
            } else {
              this.laddersPriceIndex = -1;
            }
          });
        } else {
          this.laddersPriceIndex = -1;
        }
      },
      stepperChange2(value, obj) {
        const { quantity, skuResList } = obj;
        const { currNum, minOrderQuantity } = skuResList[0];
        if (value && Number(value) > Number(currNum)) {
          value = String(Number(currNum));
        }
        if (value && Number(value) == 1 && Number(value) < Number(minOrderQuantity)) {
          value = 0;
        }
        obj.quantity = value;
      },
      stepperChange2Plus(obj) {
        const { quantity, skuResList } = obj;
        const { minOrderQuantity } = skuResList[0];

        if (Number(minOrderQuantity) && Number(quantity) < Number(minOrderQuantity)) {
          this.$nextTick(() => {
            obj.quantity = Number(minOrderQuantity);
          });
        }
      },
      selMemberVip() {
        this.$store.dispatch("app/selMemberVip").then(data => {
          this.memberVip = data && data.length ? data[0] : {};
        });
      },
      // 获取省市县 index 0-省 1-市 2-县 3-街道
      getAreas(areaId, index) {
        this.$store
          .dispatch("app/getAreas", {
            parentId: areaId
          })
          .then(data => {
            const list = data.map(item => {
              const { id, end, name } = item;
              if (end) {
                return { id, end, name };
              }
              return {
                id,
                end,
                name,
                children: []
              };
            });
            if (index === 0) {
              this.options = list;
            } else if (index === 1) {
              this.options.forEach(item => {
                if (item.id === areaId) {
                  item.children = list;
                }
              });
            } else if (index === 2) {
              const parentId = this.areaIndex[0];
              this.options.forEach(item => {
                if (item.id === parentId) {
                  item.children.forEach(item1 => {
                    if (item1.id === areaId) {
                      item1.children = list;
                    }
                  });
                }
              });
            } else if (index === 3) {
              const parentId = this.areaIndex[0];
              const cityId = this.areaIndex[1];
              this.options.forEach(item => {
                if (item.id === parentId) {
                  item.children.forEach(item1 => {
                    if (item1.id === cityId) {
                      item1.children.forEach(item2 => {
                        if (item2.id === areaId) {
                          item2.children = list;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
      },
      // 选择省市县的change事件
      areaChange(event) {
        console.log("change", event);
        const { value, tabIndex, selectedOptions } = event;
        const { end, children } = selectedOptions[tabIndex];
        if (tabIndex === 0) {
          this.areaIndex = [value, "", ""];
        } else if (tabIndex === 1) {
          const province = this.areaIndex[0];
          this.areaIndex = [province, value, ""];
        } else if (tabIndex === 2) {
          this.areaIndex[2] = value;
        }
        // end 是否结束查询 如果有子级元素结束查询
        if (end || children.length) {
          return;
        }
        const index = tabIndex + 1;
        this.getAreas(value, index);
      },
      liveClose() {
        const live = document.getElementsByClassName("nxin_live_wrap")[0];
        live.classList.remove("sildin");
        live.classList.add("sildout");
        setTimeout(() => {
          live.classList.remove("block");
        }, 500);
      },
      liveToUrl() {
        window.location.href = this.nxin_live_url;
      },
      scrollToTop() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const sticky = document.getElementsByClassName("van-sticky")[0];

        if (scrollTop < 200) {
          sticky.style.opacity = "0";
        }
        if (scrollTop > 300) {
          sticky.style.opacity = "1";
        }
      },
      validator(phone) {
        // 手机号
        // let phoneReg = /^(13[0-9]|14[01456879]|15[012356789]|16[2567]|17[0-8]|18[0-9]|19[012356789])\d{8}$/;
        const phoneReg = /^(13|14|15|16|17|18|19)\d{9}$/;
        if (phoneReg.test(phone)) {
          return true;
        }
        // 座机号
        const reg = /^(0\d{2,3})-?(\d{7,8})$/;
        return reg.test(phone);
      },
      addAddressDialog() {
        this.addAddressShow = true;
        this.addAddress = {
          name: "",
          tel: "",
          areaId: "",
          addr: "",
          isdefault: true,
          areaName: ""
        };
      },
      // 新增地址确定
      addressSave() {
        const { name, tel, addr, areaId, isdefault } = this.addAddress;
        if (!name || !tel || !addr || !areaId) {
          Toast("请补全增加信息");
          return;
        }
        const isDefault = isdefault === true ? 1 : 0;
        const params = {
          name,
          tel,
          addr,
          areaId,
          isDefault
        };
        let psdzCode = "";
        this.$store
          .dispatch("goodDetails/goodDetails/addAddr", this.$qs.stringify(params))
          .then(data => {
            if (data.deliveryId) {
              const memberDelivery = data;
              this.$store
                .dispatch(
                  "goodDetails/goodDetails/shopDeliveryList",
                  this.$qs.stringify({ deliveryId: memberDelivery.deliveryId })
                )
                .then(data1 => {
                  if (data1.deliveryList.length > 0) {
                    psdzCode = data1.deliveryList[0].areaAxis;
                    console.info(psdzCode);
                  }
                });
              this.addressList.unshift(memberDelivery);
              // 选中默认地址
              if (memberDelivery.isDefault === 1) {
                this.chosenAddressId = memberDelivery.deliveryId;
              }
              this.addAddressShow = false;
              this.addChooseShow = false;
              this.addressSelect(memberDelivery);
            }
          });
      },
      areaSelect(item) {
        console.info(item);
        this.addAreaShow = false;
        const areaName = [];
        item.selectedOptions.forEach(area => {
          areaName.push(area.name);
        });
        this.$set(this.addAddress, "areaName", areaName.join(" "));
      },
      addressSelect(item) {
        // 选择地址入口 0 送至选择入口 1集采报名 选择入口
        const isFlag = this.addrType === 0;
        const dataVal = {
          goodsIds: this.goodsId,
          areaId: item.areaId
        };
        this.$store
          .dispatch("goodDetails/goodDetails/getIsAddrSupport", this.$qs.stringify(dataVal))
          .then(data => {
            if (this.addrType !== 0) {
              if (isFlag) {
                Toast("该地址不支持配送!");
              }
              return;
            }
            this.$set(this.deliveryVO, "isMatching", data.isMatching);
            this.$set(this.deliveryVO, "memberDeliveryEntity", item);
            this.chosenAddressId = item.deliveryId;

            this.toFreightAmount(item.areaAxis);
            // 异步修改地址信息
            this.$store
              .dispatch(
                "goodDetails/goodDetails/updateAddr",
                this.$qs.stringify({ deliveryId: item.deliveryId })
              )
              .then(data1 => {
                console.info(data1);
                this.addChooseShow = false;
              });
          });
      },
      addressDialog() {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        this.addChooseShow = true;
      },
      getGoodsDetail(params, from) {
        const param = {
          goodsId: this.goodsId,
          fromShopId: params.fromShopId,
          shareBoId: params.shareBoId,
          businessSource: params.source
        };

        this.$store
          .dispatch("goodDetails/goodDetails/detail", this.$qs.stringify(param))
          .then(data => {
            Toast.clear();

            if (data.data && data.data.specGroupInfo) {
              data.data.specGroupInfo.forEach(item => {
                item.quantity = 0;
              });
            }
            this.detail = data.data || {};
            // 商品不存在或已下架

            if (data.code === "402003" || data.code === "402008") {
              const ua = navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //eslint-disable-line
                wx.miniProgram.getEnv(res => {
                  if (res.miniprogram) {
                    // 小程序
                    wx.miniProgram.navigateTo({
                      url: `${process.env.VUE_APP_APP}mob/goods/toCommodityShelves?goodsId=${this.goodsId
                        }`
                    });
                  }
                });
              }
              window.location.href = `${process.env.VUE_APP_APP
                }mob/goods/toCommodityShelves?goodsId=${this.goodsId}`;
              return;
            }
            // 判断商品品类--商业服务跳转
            if (this.detail.axisStr.indexOf("$4616$") > -1) {
              window.location.href = `${process.env.VUE_APP_WEB_QLW}appmrket/shopjump?t=m&id=${this.goodsId
                }`;
              return;
            }
            // 设置标题
            document.title = this.detail.name;
            // 设置多规格
            // specType  1：多规格
            // specialInfo  所有规格信息字符串类型
            // specialList  规格信息，数组类型
            // skuSpecsIndex  当前商品规格值
            const {
              specType,
              specialList,
              skuSpecsIndex,
              minOrderQuantity,
              goodsPrice,
              sUnitCn,
              unitRatio
            } = this.detail;
            if (
              goodsPrice.commonLaddersPrice &&
              goodsPrice.commonLaddersPrice.goodsPriceList &&
              goodsPrice.commonLaddersPrice.goodsPriceList.length &&
              sUnitCn &&
              Number(unitRatio) !== 1
            ) {
              const goodsPriceList = goodsPrice.commonLaddersPrice.goodsPriceList.map(item => {
                const sunitPrice = Number(item.price) / Number(unitRatio);
                return {
                  ...item,
                  unitRatioStr: `${sunitPrice.toFixed(2)}元/${sUnitCn}`
                };
              });
              this.detail.goodsPrice.commonLaddersPrice.goodsPriceList = goodsPriceList;
            }
            if (from === "skuClick") {
              this.stepperChange(this.addCartNum);
            } 
            this.addCartNum = 1;
            if (minOrderQuantity && minOrderQuantity > 1) {
              this.addCartNum = minOrderQuantity;
            }
            
            if (specType === 1) {
              const skuSpecsList = skuSpecsIndex.split(" ");
              this.specification = {
                specType,
                specialList,
                skuSpecsList
              };
            }

            this.isGiftJump();
            this.getAdList();
            this.evaluationList();
            this.detailMore();
            this.getLoadGoods();
            this.getCountCart();
            this.saveVisitRecord(this.$route.query.shareBoId);

            const { spuId, isGroup } = data.data;
            // 商品评价
            getGoodsEvaluateList({
              pageNum: 1,
              pageSize: 3,
              spuId
            }).then(res => {
              this.goodsEvaluateList = res.data.list;
            });
            getGoodsEvaluateCollect({
              spuId
            }).then(res => {
              this.goodsEvaluateCollect = res.data;
            });

            // 查询套餐
            if (isGroup && isGroup == 1) {
              // 套餐
              getPackageSkuList({
                mainSkuId: this.goodsId
              }).then(res => {
                this.packageSkuList = res.data || [];
                console.log("packageSkuList: ", this.packageSkuList);
              });
            }

            if (this.detail.imgUrls && this.detail.imgUrls.length > 0) {
              this.imgSize = this.detail.imgUrls.length;
              if (this.detail.videoUrl) {
                this.imgSize = this.detail.imgUrls.length + 1;
              }
            }
            if (!this.detail.promotion) {
              this.detail.promotion = {};
            }
            // 是否收藏货品
            this.isGoodCollect = this.detail.favoriteGoods;
            // 是否收藏店铺
            this.isShopCollect = this.detail.favoriteShop;
            // 配送名称
            if (this.detail.shopDtlEntity.shippingType === 1) {
              if (this.detail.goodsShopDelivery.isPs === 1) {
                this.isPs = true;
              }
            } else if (this.detail.shopDtlEntity.shippingType === 2) {
              if (this.detail.goodsShopDelivery.isZt === 1) {
                this.isZt = true;
              }
            } else if (this.detail.shopDtlEntity.shippingType === 3) {
              if (this.detail.goodsShopDelivery.isZt === 1) {
                this.isZt = true;
              }
              if (this.detail.goodsShopDelivery.isPs === 1) {
                this.isPs = true;
              }
            }
            // 地址
            this.deliveryVO = this.detail.memberDeliveryVO || {};
            this.addressList = this.deliveryVO.memberDeliveryList || [];
            if (this.deliveryVO.memberDeliveryEntity) {
              // 默认选中地址
              this.chosenAddressId = this.deliveryVO.memberDeliveryEntity.deliveryId;
            }
            // 配送地址
            const psDeliveryList = [];
            const ztDeliveryList = [];
            this.detail.goodsShopDelivery.deliveryList.forEach(shopDelivery => {
              if (shopDelivery.type === 1) {
                psDeliveryList.push(shopDelivery);
              }
              if (shopDelivery.type === 2) {
                ztDeliveryList.push(shopDelivery);
              }
            });
            this.psDeliveryList = psDeliveryList;
            this.ztDeliveryList = ztDeliveryList;
            // 运费计算
            const areaAxis = this.deliveryVO.memberDeliveryEntity
              ? this.deliveryVO.memberDeliveryEntity.areaAxis
              : "";
            this.toFreightAmount(areaAxis);
            // 活动结束时间
            if (this.detail.promotion && this.detail.promotion.isPromotion === 1) {
              this.time = this.detail.promotion.endDateLong - new Date().getTime();
            }
            // 套餐名称
            if (this.detail.goodsList && this.detail.goodsList.length > 0) {
              const goodsNameArray = [];
              this.detail.goodsList.forEach(goods => {
                goodsNameArray.push(goods.name);
              });
              this.comboGoodsName = goodsNameArray.join(" + ");
            }
            // 初始化
            this.initData();
            if (this.detail.videoUrl) {
              this.video.url = this.detail.videoUrl;
              this.video.cover = `${this.detail.videoUrl
                }?vframe/png/offset/1/h/750/imageMogr2/thumbnail/80000@`;
              this.detail.videoCover = `${this.detail.videoUrl
                }?vframe/png/offset/1/h/750/imageMogr2/thumbnail/80000@`;
              this.playerOptions.sources[0].src = this.detail.videoUrl;
              this.playerOptions.poster = `${this.detail.videoUrl
                }?vframe/png/offset/1/h/750/imageMogr2/thumbnail/80000@`;
            }
          })
          .catch(() => {
            Toast.clear();
          });
      },
      shopCollect() {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        if (!this.isShopCollect) {
          const favoriteArr = [
            {
              type: 2,
              resId: this.detail.goodsShop.shopIdStr
            }
          ];
          this.addFavorite(favoriteArr);
        } else {
          const favorite = {
            type: 2,
            resId: this.detail.goodsShop.shopIdStr
          };
          this.delFavorite(favorite);
        }
      },
      goodCollect() {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        if (!this.isGoodCollect) {
          const favoriteArr = [
            {
              type: 1,
              categoryId: this.detail.categoryId,
              resId: this.goodsId,
              fromShopId: this.detail.shopIdStr
            }
          ];
          this.addFavorite(favoriteArr);
        } else {
          const favorite = {
            type: 1,
            categoryId: this.detail.categoryId,
            resId: this.goodsId,
            fromShopId: this.detail.shopIdStr
          };
          this.delFavorite(favorite);
        }
      },
      addFavorite(favorite) {
        let toastIcon = "";
        this.$store
          .dispatch("member/member/addFavorite", {
            json: encodeURIComponent(JSON.stringify(favorite))
          })
          .then(() => {
            if (favorite[0].type === 1) {
              this.isGoodCollect = true;
              toastIcon = "like-o";
            } else {
              this.isShopCollect = true;
              toastIcon = "star-o";
            }
            // like-o
            Toast({
              message: "收藏成功",
              icon: toastIcon
            });
          });
      },
      delFavorite(favorite) {
        let toastIcon = "";
        this.$store
          .dispatch("member/member/delRecordFavorite", this.$qs.stringify(favorite))
          .then(() => {
            if (favorite.type === 1) {
              this.isGoodCollect = false;
              toastIcon = "like-o";
            } else {
              this.isShopCollect = false;
              toastIcon = "star-o";
            }
            Toast({
              message: "取消收藏成功",
              icon: toastIcon
            });
          });
      },
      swipeChange(index) {
        this.current = index;
        this.isShowVideo = true;
        $(".video-wrap video")
          .get(0)
          .pause();
      },
      showVideo() {
        this.isShowVideo = false;
        $(".video-wrap video")
          .get(0)
          .play();
      },

      distributionSelect(item) {
        this.distributionName = item.name;
      },
      toAllTeam() {
        window.location.href = `${process.env.VUE_APP_APP}mob/groupPurchase/toAllTeam?goodsId=${this.goodsId
          }&promotionId=${this.detail.promotion.promotionId}`;
      },
      toJoinTeam(teamId) {
        window.location.href = `${process.env.VUE_APP_APP}mob/groupPurchase/toGroupPurchaseJoinTeam/
      ${this.goodsId}/${teamId}?fromShopId=${this.detail.shopIdStr}`;
      },
      toImg(url) {
        window.location.href = url;
      },
      getAdList() {
        const that = this;
        $.ajax({
          url: "https://graphicinformation.nxin.com/getJsonFormatAdList/202",
          dataType: "jsonp",
          success(data) {
            that.adList = data;
          }
        });
      },
      getCountCart() {
        this.$store.dispatch("member/member/getCountCart", this.$qs.stringify({})).then(data => {
          this.countCart = data || 0;
        });
      },
      // 跳转到评论详情
      commentDetail() {
        window.location.href = `${process.env.VUE_APP_APP}vm2/comment/list/list?spuId=${this.detail.spuId
          }`;
      },
      evaluationList() {
        const param = {
          goodsId: this.goodsId,
          pageNum: 1,
          pageSize: 3
        };
        this.$store.dispatch("goodDetails/goodDetails/evaluationList", param).then(data => {
          this.evaluate = data || {};
        });
      },
      detailMore() {
        const param = {
          goodsId: this.goodsId
        };
        this.$store
          .dispatch("goodDetails/goodDetails/detailMore", this.$qs.stringify(param))
          .then(data => {
            const itemV2 =
              (data.description ? data.description : "") + (data.feature ? data.feature : "");
            const itemV3 =
              (data.usingMethod ? data.usingMethod : "") + (data.attention ? data.attention : "");
            this.$set(this.detailContent, "itemV2", itemV2);
            this.$set(this.detailContent, "itemV3", itemV3);
            if (data.detail) {
              this.detailHtml = this.resetImg(data.detail);
            }
          });
      },
      // 处理图片
      resetImg(html) {
        const newContent = html.replace(/<img[^>]*>/gi, str => {
          // eslint-disable-next-line
          const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          const url = str.match(srcReg);
          // eslint-disable-next-line
          let dataSrc = url[1];
          if (dataSrc.includes("?")) {
            dataSrc = `${url[1]}&imageMogr2/auto-orient/thumbnail/1200000@`;
          } else {
            dataSrc = `${url[1]}?imageMogr2/auto-orient/thumbnail/1200000@`;
          }
          const mat = str.replace(
            // eslint-disable-next-line no-useless-escape
            /src=\"(.*)\"/gi,
            `data-src=${dataSrc} style="width:100%;"`
          );
          return mat;
        });
        return newContent;
      },
      // 重设图片大小
      resizeImg(h) {
        Zepto(`${h} img`).each((t, i) => {
          Zepto(i).css("width", "100%");
          const imgUrl = `${Zepto(i).attr("data-src")}?imageMogr2/auto-orient/thumbnail/1200000@`;
          Zepto(i).attr("data-src", imgUrl);
        });
      },
      // 点击全部货品
      shopQBHP() {
        sessionStorage.clear();
        window.location.href = `${process.env.VUE_APP_taaspublic}?shopId=${this.detail.shopIdStr
          }&forward_id=${this.detail.typeId}`;
      },
      // 跳转到风险提示
      riskWarning() {
        window.location.href = `${process.env.VUE_APP_APP}mob/goods/toRisk.do`;
      },
      getLoadGoods() {
        const param = {
          goodsId: this.goodsId,
          fromShopId: this.$route.query.fromShopId
        };
        console.log(param);
        this.$store.dispatch("goodDetails/goodDetails/loadGoods", param).then(data => {
          if (!data) {
            return;
          }
          let goodsCouponName = "";
          if (data.couponList && data.couponList.length > 0) {
            // 优惠券
            for (let i = 0; i < data.couponList.length; i += 1) {
              goodsCouponName += `满${data.couponList[i].regKey}元减${data.couponList[i].regVal}元，`;
              if (i > 0) {
                break;
              }
            }
            this.goodsCouponName = goodsCouponName.slice(0, -1);
            data.couponList.forEach(coupon => {
              coupon.couponTypeName = this.getTypeName(coupon);
            });
          }
          if (data.myShopCouponList && data.myShopCouponList.length > 0) {
            data.myShopCouponList.forEach(coupon => {
              coupon.couponTypeName = this.getTypeName(coupon);
            });
          }
          this.loadGoods = data;
          // 可领取的优惠券
          const fetchCoupon = [];
          // 本品可用的优惠券
          const goodsCoupon = [];
          // 已领取的优惠券
          const receivedCoupon = [];
          if (this.loadGoods.couponList) {
            this.loadGoods.couponList.forEach(coupon => {
              if (
                (coupon.isReceive !== 1 || coupon.fetchLimit > 1) &&
                coupon.userFetchNum < coupon.fetchLimit &&
                coupon.surplusNum > 0
              ) {
                fetchCoupon.push(coupon);
              }
            });
          }
          if (this.loadGoods.myShopCouponList) {
            this.loadGoods.myShopCouponList.forEach(coupon => {
              if (coupon.isGoodsAvailable === 1) {
                goodsCoupon.push(coupon);
              } else {
                receivedCoupon.push(coupon);
              }
            });
          }
          this.fetchCoupon = fetchCoupon;
          this.goodsCoupon = goodsCoupon;
          this.receivedCoupon = receivedCoupon;
        });
      },
      getTypeName(coupon) {
        let couponTypeName = "";
        if (coupon.busId.indexOf("SHOP#FFFF") !== -1) {
          if (coupon.regVal === coupon.regKey) {
            couponTypeName = "全品类(特例商品除外)";
          } else {
            couponTypeName = coupon.regName;
          }
        } else if (coupon.applyRangeExplain !== "") {
          couponTypeName = coupon.applyRangeExplain;
        } else if (coupon.busType === "SHOP") {
          couponTypeName = "全店通用";
        } else if (coupon.busType === "GOODS") {
          couponTypeName = "店铺指定商品可用";
        } else if (coupon.busType === "CATE") {
          couponTypeName = "指定分类商品可用";
        }
        return couponTypeName;
      },
      freightCheck(item) {
        this.freight = item;
        this.freightShow = false;
      },
      toFreightAmount(areaAxis) {
        this.freightList = [];
        this.freight = {};
        const tId = this.detail.shopTemplateIdStr;
        const refId = this.detail.fundShopId;
        const { goodsId } = this.detail;
        const goodsMoney = this.detail.goodsPrice.sellFactPrice;
        if (!areaAxis) {
          this.$set(this.freight, "freightMoney", "请选择收货地址！");
          return;
        }
        const areaId = areaAxis.split("$")[2];
        const { isMatching } = this.deliveryVO;
        if (parseInt(isMatching, 0) === 0) {
          this.$set(this.freight, "freightMoney", "暂无运费报价");
          return;
        }
        const param = {
          tId,
          refId,
          goodsId,
          areaId,
          areaAxis,
          num: 1,
          weight: 1,
          goodsMoney
        };
        this.$store.dispatch("goodDetails/goodDetails/getFreightAmount", param).then(data => {
          const amountRq = data.goodsFreightAmountRq;
          if (
            !amountRq ||
            amountRq.code !== "0" ||
            amountRq.data.goodsFreightResFormList.length <= 0
          ) {
            this.$set(this.freight, "freightMoney", "具体运费请联系卖家");
            return;
          }
          const dataNew = amountRq.data.goodsFreightResFormList;
          if (dataNew[0].type === "LXMJ") {
            this.$set(this.freight, "freightMoney", "具体运费请联系卖家");
            return;
          }
          if (dataNew[0].type === "BY") {
            this.$set(this.freight, "freightMoney", "包邮");
          } else if (dataNew[0].type === "ZDYYF" && dataNew[0].transMode === "KD") {
            const freightMoney = `${parseFloat(dataNew[0].freightMoney).toFixed(2)}元`;
            this.$set(this.freight, "freightMoney", freightMoney);
          } else if (dataNew[0].type === "ZDYYF" && dataNew[0].transMode !== "KD") {
            this.freightList = dataNew;
          }
        });
      },
      zixun() {
        if (isInNxinApp()) {
          if (!common.isLogin(this.userInfo.id)) {
            return;
          }
          const param = { goodsId: this.goodsId };
          this.$store
            .dispatch("goodDetails/goodDetails/findBoIdByGoodsId", { params: param })
            .then(data => {
              znt.openContactChat({ archiveId: data });
            });
        } else {
          window.location.href = "https://znt.nxin.com";
        }
      },
      cart() {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        // window.location.href = '/vm/cart';
        let retUrl = "/mob/cart/cartInfoList.do";
        const typeId = common.getCookie("typeId");
        if (typeId) {
          retUrl = `${retUrl}?typeId=${typeId}`;
        }
        window.location.href = retUrl;
      },
      qr() {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
        // 点击生成海报
        const param = {
          goodsId: this.goodsId,
          goodsName: this.detail.name,
          goodsImg: encodeURIComponent(this.detail.imgUrl1),
          shareUrl: encodeURIComponent(this.getShareUrl())
        };
        this.$store.dispatch("goodDetails/goodDetails/genBill", { params: param }).then(data => {
          if (data.code === "0") {
            const ua = navigator.userAgent.toLowerCase();
            if (isInNxinApp()) {
              // 智农通
              this.showBill(data);
            } else if (ua.match(/MicroMessenger/i) == "micromessenger") {
              //eslint-disable-line
              wx.miniProgram.getEnv(res => {
                if (res.miniprogram) {
                  // 小程序登录
                  const imgUrl = encodeURIComponent(data.data.billImgUrl);
                  const h5Url = encodeURIComponent(this.getShareUrl());
                  wx.miniProgram.navigateTo({
                    url: `/pages/image/image?imgUrl=${imgUrl}&h5Url=${h5Url}`
                  });
                  Toast.clear();
                } else {
                  this.showBill(data);
                }
              });
            } else {
              this.showBill(data);
            }
          } else {
            Toast.clear();
            Toast("生成失败,请稍后重试");
          }
        });
      },
      showBill(data) {
        const that = this;
        $.get(data.data.billImgUrl, () => {
          Toast.clear();
          this.posterShow = true;
          that.billImgUrl = data.data.billImgUrl;
          if (isInZnt() && getZntVersion() >= "5.30") {
            // 展示海报按钮
            this.saveBillBtn = true;
          }
        }).fail(() => {
          Toast.clear();
          Toast("生成失败,请稍后重试");
        });
      },
      saveBill() {
        if (!this.billImgUrl) {
          return;
        }
        znt.saveImage({
          image: this.billImgUrl, // 支持链接和base64图片编码。base64图片编码，需包含 data:image/jpeg(或png);base64,..的完整串
          success() { },
          fail() { }
        });
      },
      // 点击分享
      share() {
        // 判断是否是在智农通内
        if (isInZnt()) {
          const { detail, VUE_APP_SC, goodsId } = this;
          const shareImgUrl = `${detail.imgUrl1}?imageView2/1/w/200/h/200`;
          const wxAppPath = `pages/h5/h5?url=${encodeURIComponent(
            `${VUE_APP_SC}vm/goodDetails/${goodsId}?fromShopId=${detail.shopIdStr}&shareBoId=${detail.memberInfo && detail.memberInfo.boids ? detail.memberInfo.boids : "0"
            }`
          )}`;
          console.log("wxAppPath", wxAppPath);
          const { nmGoodsIntroduce = "" } = this.detail;
          znt.openSharePanel({
            title: this.detail.shareInfo,
            desc: $.trim(nmGoodsIntroduce.replace(/\s+/g, "")),
            link: this.getShareUrl(),
            imgUrl: $.trim(shareImgUrl),
            wxAppId: "gh_c0cc450225e2",
            wxAppPath,
            success() {
              this.$store.dispatch("goodDetails/goodDetails/getAddTaskGrantPoints", {}).then(data => {
                console.info(data);
              });
            }
          });
        } else {
          this.isShowShare = true;
        }
      },
      initData() {
        const { shareInfo = "", nmGoodsIntroduce = "" } = this.detail;
        // 微信
        const shareImgUrl = `${this.detail.imgUrl1}?imageView2/1/w/200/h/200`;
        const paramWeixin = {
          title: $.trim(shareInfo.replace("/r/n", "")),
          desc: $.trim(nmGoodsIntroduce.replace(/\s+/g, "")),
          link: this.getShareUrl(),
          imgUrl: $.trim(shareImgUrl)
        };
        WeiXinShare.init(paramWeixin);
        // 初始化分享
        const titleShare = $.trim(shareInfo.replace("/r/n", ""));
        if (common.isInWeiXin()) {
          console.info("初始化分享");
          common.initShare(
            titleShare,
            $.trim(nmGoodsIntroduce.replace(/\s+/g, "")) || "",
            this.getShareUrl(),
            `${this.detail.imgUrl1}`
          );
        }
      },
      isClose() {
        this.isShowShare = false;
      },
      getShareUrl() {
        let url = window.location.href;
        if (url && url.indexOf("?") > -1) {
          url = url.substring(0, url.indexOf("?"));
        }
        const { shopIdStr, typeId } = this.detail;
        const forwardId = typeId ? typeId.trim() : "";
        url = `${url}?fromShopId=${shopIdStr}&forward_id=${forwardId}`;
        if (this.userInfo.id) {
          const shareBoId = this.userInfo.id;
          url = `${url}&shareBoId=${shareBoId}`;
        }
        console.log("分享链接", url);
        return url;
      },
      // 加入购物车
      getBuyParams() {
        return {
          goodsIdTo: this.goodsId,
          currQuantity: this.detail.currQuantity, // 商品当前库存
          isOa: this.detail.isOa, // 是否OA商品
          stockType: this.detail.stockType, // OA库存类型
          countNum: this.addCartNum,
          source: this.source, // 配送方式、加入购物车、立即购买标识
          shopId: this.detail.shopIdStr,
          fundShopId: this.detail.fundShopId,
          userShopId: this.detail.shopEntity ? this.detail.shopEntity.shopIdStr : "", // 登陆人店铺ID
          isPromotion: this.detail.promotion.isPromotion,
          promotionId: this.detail.promotion.promotionId,
          shareBoId: this.detail.shareBoId ? this.detail.shareBoId : "",
          goodsOrShopUrl: window.location.href,
          promotionMinimum: this.detail.promotion.promotionMinimum, // 集采最小起订量
          promotionLimitation: this.detail.promotion.promotionLimitation,
          isMatching: this.deliveryVO.isMatching,
          yetBuyNum: this.detail.yetBuyNum,
          isGroupTeam: this.detail.promotion.isGroupTeam,
          promotionRemain: this.detail.promotion.promotionRemain,
          marginProportion: this.detail.promotion.marginProportion, // 保证金比例
          marginPrice: this.detail.promotion.marginPrice, // 保证金金额
          userName: this.detail.memberInfo ? this.detail.memberInfo.realName : "",
          userPhone: this.detail.memberInfo ? this.detail.memberInfo.mobilePhone : "",
          promotionPrice: this.detail.promotion.promotionPrice, // 优惠价
          goodsSpec: this.detail.spec,
          addr: this.deliveryVO.memberDeliveryEntity
            ? this.deliveryVO.memberDeliveryEntity.areaFullName
            : "", // 地址信息
          sellFactPrice: this.detail.goodsPrice.sellFactPrice
        };
      },
      getBuyRetUrl(buyParams) {
        let { goodsOrShopUrl } = buyParams;
        if (goodsOrShopUrl && goodsOrShopUrl.indexOf("?") > -1) {
          const index = goodsOrShopUrl.indexOf("?");
          goodsOrShopUrl = goodsOrShopUrl.substring(0, index);
        }
        // 回调路径
        let retUrl = `${goodsOrShopUrl}?isBuy=${buyParams.countNum}&source=${buyParams.source
          }&fromShopId=${buyParams.fromShopId}`;
        if (buyParams.shareBoId) {
          retUrl = `${retUrl}&shareBoId=${buyParams.shareBoId}`;
        }
        if (!common.isLogin(this.userInfo.id)) {
          return "";
        }
        return retUrl;
      },
      laddersChoose(index) {
        if (this.detail.commonLaddersPrice) {
          this.addCartShow = true;
          return;
        }
        this.laddersPriceIndex = index;
        this.addCart(1);
        const item = this.detail.goodsPrice.commonLaddersPrice.goodsPriceList[index];
        this.addCartNum = item.minQuantity;
      },
      addCart(source) {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        this.addCartType = 2;
        this.source = source;
        this.addCartShow = true;
        // this.goodsPrice = this.detail.goodsPrice.sellFactPrice;
        // if (this.source === 2) {
        //   this.goodsPrice = this.detail.goodsPrice.sellPrice;
        // }
        // 集采价购买
        if (this.source === 3 && this.detail.promotion.isGroupTeam === 0) {
          this.addCartNum = this.detail.promotion.promotionMinimum;
        }
      },
      choosedCard() {
        if (this.detail.currQuantity > 0) {
          this.addCartType = 1;
          this.addCartShow = true;
          // this.goodsPrice = this.detail.goodsPrice.sellFactPrice;
        }
      },
      async buy(source) {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        console.log("buySource", source);
        const buyParams = this.getBuyParams();
        if (source === 0 || source) {
          buyParams.source = source;
        }
        // 是否询价商品
        const enquiry = !buyParams.sellFactPrice || Number(buyParams.sellFactPrice) <= 0;
        /* if (this.isPs && !enquiry && buyParams.source !== 1 && parseInt(buyParams.isMatching, 0) === 0) {
          Toast('此商品不支持在当前地区销售');
          return;
        } */
        /* if (this.isPs && !enquiry && (buyParams.addr === '' || buyParams.addr == null)) {
          Toast('请选择配送地址');
          return;
        } */
        // 回调路径
        const retUrl = this.getBuyRetUrl(buyParams);
        if (!retUrl) {
          return;
        }
        if (buyParams.source < 3 && enquiry) {
          this.isToNotifyTheSeller(buyParams);
          return;
        }

        const { detail } = this;
        if (detail.commonLaddersPrice) {
          const arr = [];
          const commonLaddersTotal = detail.specGroupInfo.reduce((total, item) => {
            if (Number(item.quantity)) {
              arr.push(item);
            }
            return total + Number(item.quantity);
          }, 0);
          if (!commonLaddersTotal) {
            Toast("购买数量不能小于等于0");
            return;
          }

          const isPass = false;
          Toast.loading({
            mask: true,
            message: "加载中...",
            duration: 0
          });
          for (let item = 0; item < arr.length; item++) {
            const { code } = await this.$store.dispatch(
              "goodDetails/goodDetails/buyskip",
              this.$qs.stringify({
                goodsId: arr[item].skuResList[0].goodsId,
                buyNum: arr[item].quantity
              })
            );

            if (code === 6) {
              Toast("该货品是自己店铺的商品不能选购！");
              return;
            }
          }

          if (buyParams.source === 0) {
            Toast.clear();
            this.buyNow(buyParams); // 立即购买
          } else if (buyParams.source === 1) {
            this.joinShoppingCart(buyParams, arr); // 加入购物车
          }
        } else {
          if (buyParams.countNum <= 0) {
            Toast("购买数量不能小于等于0");
            return;
          }
          // 库存校验
          if (
            (buyParams.source === 0 || buyParams.source === 1) &&
            (buyParams.isOa !== 1 || buyParams.stockType === 1 || buyParams.stockType === 2)
          ) {
            if (
              Number(buyParams.countNum) > Number(buyParams.currQuantity) &&
              buyParams.isPromotion !== 1
            ) {
              Toast("购买数量已大于当前库存");
              return;
            }
          }

          this.addCartShow = false;

          const params = { goodsId: buyParams.goodsIdTo, buyNum: buyParams.countNum };
          this.$store
            .dispatch("goodDetails/goodDetails/buyskip", this.$qs.stringify(params))
            .then(data => {
              if (data.code === 6) {
                Toast("该货品是自己店铺的商品不能选购！");
                return;
              }

              if (buyParams.source === 0) {
                this.buyNow(buyParams); // 立即购买
              } else if (buyParams.source === 1) {
                this.joinShoppingCart(buyParams); // 加入购物车
              } else if (buyParams.source === 2) {
                this.buyNowJicai(buyParams); // 集采市场价购买
              } else if (buyParams.source === 3) {
                this.addGroupPriceGoods(); // 集采价购买商品
              }
            });
        }
      },
      // 立即购买
      buyNow(buyParams) {
        const {
          detail,
          deliveryVO: { memberDeliveryEntity }
        } = this;
        if (this.isPs && (!memberDeliveryEntity || !memberDeliveryEntity.deliveryId)) {
          Toast("请先设置收货地址");
          return;
        }
        let orderCartEntity = [
          {
            skuId: buyParams.goodsIdTo,
            quantity: buyParams.countNum,
            fromShopId: buyParams.shopId,
            memberDeliveryId: this.deliveryVO.memberDeliveryEntity.deliveryId,
            shareBoId: buyParams.shareBoId
          }
        ];
        if (detail.commonLaddersPrice) {
          const orderCartlist = [];
          detail.specGroupInfo.forEach(item => {
            if (item.quantity) {
              orderCartlist.push({
                skuId: item.skuResList[0].goodsId,
                quantity: item.quantity,
                fromShopId: item.skuResList[0].shopIds,
                memberDeliveryId: this.deliveryVO.memberDeliveryEntity.deliveryId,
                shareBoId: buyParams.shareBoId
              });
            }
          });
          orderCartEntity = orderCartlist;
        }
        // const paramInfo = {cartItemReqFormList: orderCartEntity};
        // window.location.href = `${process.env.VUE_APP_APP}vm2/order/buyer/orderSubmit/index?data=${JSON.stringify(paramInfo)}`;
        const goodsInJson = JSON.stringify(orderCartEntity);
        // 去结算前校验是否有购买商品活动限制
        const params = { wfg_goodsList: goodsInJson };
        this.$store
          .dispatch("goodDetails/goodDetails/checkGoods", this.$qs.stringify(params))
          .then(data => {
            if (data.status === 0) {
              Toast("此货品超过个人限购数不能进行购买");
              return;
            }

            const paramInfo = {
              cartItemReqFormList: orderCartEntity,
              shareBoId: buyParams.shareBoId
            };
            console.log("立即购买参数：", JSON.stringify(paramInfo));
            const uuid = common.guid();
            localStorage.setItem(uuid, `${JSON.stringify(paramInfo)}`);
            window.location.href = `${process.env.VUE_APP_APP
              }vm2/order/buyer/orderSubmit/index?subkey=${uuid}&sources=0`;
          });
      },
      // 加入购物车
      async joinShoppingCart(buyParams, arr) {
        if (this.detail.commonLaddersPrice) {
          let isPass = false;
          for (let item = 0; item < arr.length; item++) {
            const { success, errorcode, errormsg } = await this.$store.dispatch(
              "goodDetails/goodDetails/addCart",
              {
                params: {
                  goodsId: arr[item].skuResList[0].goodsId,
                  goodsQuantity: arr[item].quantity,
                  fromShopId: arr[item].skuResList[0].shopIds,
                  shareBoId: buyParams.shareBoId
                }
              }
            );

            if (!success) {
              Toast(errormsg);
              return;
            }
            if (errorcode === -2) {
              window.location.href = `${process.env.VUE_APP_APP
                }mob/goods/isShowDisplayPrice.do?goodsId=${arr[item].skuResList[0].goodsId
                }&url=/mob/shop/shopDetail/${arr[item].skuResList[0].shopIds}`;
            }
            isPass = success;
          }
          Toast.clear();

          if (isPass) {
            this.getCountCart();
            Toast("添加成功");
            this.addCartShow = false;
          } else {
            Toast(data.errormsg);
          }

          return;
        }

        this.addCartShow = false;
        if (buyParams.currQuantity < 1) {
          Toast("此货品库存不足");
          return;
        }
        const params = {
          goodsId: buyParams.goodsIdTo,
          goodsQuantity: buyParams.countNum,
          fromShopId: buyParams.shopId,
          shareBoId: buyParams.shareBoId
        };
        Toast.clear();
        this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then(data => {
          if (data.success === true) {
            this.getCountCart();
            Toast("添加成功");
          } else if (data.errorcode === -2) {
            window.location.href = `${process.env.VUE_APP_APP
              }mob/goods/isShowDisplayPrice.do?goodsId=${buyParams.goodsIdTo
              }&url=/mob/shop/shopDetail/${buyParams.shopId}`;
          } else {
            Toast(data.errormsg);
          }
        });
      },
      // 集采——市场价购买去支付
      buyNowJicai(buyParams) {
        const orderCartEntity = [
          {
            skuId: buyParams.goodsIdTo,
            quantity: buyParams.countNum,
            fromShopId: buyParams.shopId,
            isYxGroup: "",
            yxGroupId: "",
            memberDeliveryId: this.deliveryVO.memberDeliveryEntity.deliveryId,
            shareBoId: buyParams.shareBoId
          }
        ];

        const paramInfo = { cartItemReqFormList: orderCartEntity, shareBoId: buyParams.shareBoId };
        console.log("立即购买参数：", JSON.stringify(paramInfo));
        const uuid = common.guid();
        localStorage.setItem(uuid, `${JSON.stringify(paramInfo)}`);
        window.location.href = `${process.env.VUE_APP_APP
          }vm2/order/buyer/orderSubmit/index?subkey=${uuid}&sources=0`;
      },
      // 新增集采报名，并跳转订单提交页 JiaCheng 2017-12-13
      addGroupPriceGoods() {
        const buyParams = this.getBuyParams();
        const goodsId = buyParams.goodsIdTo;
        const {
          shopId,
          promotionMinimum,
          promotionLimitation,
          isGroupTeam,
          yetBuyNum,
          shareBoId
        } = buyParams;
        const { promotionId } = buyParams;
        const goodsNum = buyParams.countNum;
        if (!/^\d{1,10}$/.test(goodsNum)) {
          Toast("购买数量只能是正数");
          return;
        }
        if (
          Number(isGroupTeam) === 1 &&
          Number(goodsNum) > Number(promotionLimitation) - Number(yetBuyNum)
        ) {
          Toast(`该活动每人最多可购买${promotionLimitation}件！您已购${yetBuyNum}件`);
          return;
        }
        if (Number(isGroupTeam) === 0 && Number(goodsNum) < Number(promotionMinimum)) {
          Toast("购买数量不能小于最小起购数量");
          return;
        }
        if (Number(goodsNum) > Number(buyParams.promotionRemain)) {
          Toast("购买总数量超过活动剩余数量，暂时不能购买");
          return;
        }
        const params = {
          goodsId,
          promotionId,
          isGroupTeam,
          goodsNum,
          personName: buyParams.userName,
          cellPhone: buyParams.userPhone,
          goodsPrice: this.detail.promotion.promotionPrice,
          goodsSpec: buyParams.goodsSpec,
          addr: buyParams.addr,
          marginPrice: buyParams.marginPrice,
          percent: buyParams.marginProportion // 保证金比例
        };
        this.$store
          .dispatch("goodDetails/goodDetails/insertGoodsGroupPurchase", { params })
          .then(data => {
            const dataCode = data.code;
            if (dataCode === "1") {
              // 冻结成功
              const { groupId } = data;
              const orderCartEntity = [
                {
                  fromShopId: shopId,
                  fundShopId: shopId,
                  goodsId,
                  goodsQuantity: goodsNum,
                  promotionId,
                  goodsGroupPurchaseId: groupId,
                  shareBoId,
                  memberDeliveryId: this.deliveryVO.memberDeliveryEntity.deliveryId
                }
              ];
              const carts = encodeURIComponent(JSON.stringify(orderCartEntity));
              window.location.href = `${process.env.VUE_APP_APP
                }mob/order/confirmOrder.do?isGroupPurchase=0&goodsId=${this.goodsId}&carts=${carts}`;
            } else if (data.code === "2") {
              // 冻结失败-去充值
              /* $("#bmFail").show();
               $("#url").val(data.url);
               $("#scUrl").val(data.scUrl);
               req=data.req; */
              Toast("冻结失败-去充值");
            } else {
              Toast(data.message);
              /* window.location.href = `${process.env.VUE_APP_APP}vm/goodDetails/${goodsId}`; */
            }
          });
      },
      getCouponTo(coupon) {
        const { busType, subBusId, busId, cpChannel, cpId } = coupon;
        const couPonStr = `满${coupon.regKey}减${coupon.regVal}`;
        // 支持全店铺
        if (subBusId.indexOf("SHOP#FFFF") !== -1) {
          window.location.href = `${process.env.VUE_APP_APP
            }mob/goods/goodsList.do?shopIds=''&couPonStr=${couPonStr}`;
          return;
        }
        if (busType === "SHOP") {
          if (subBusId.split(",").length > 1) {
            window.location.href = `${process.env.VUE_APP_APP
              }mob/goods/goodsList.do?shopIds=${subBusId}&couPonStr=${couPonStr}`;
          } else {
            window.location.href = `${process.env.VUE_APP_APP
              }mob/shop/shopDetail/${subBusId}?couPonStr=${couPonStr}`;
          }
        } else if (busType === "GOODS") {
          if (cpChannel === "PLATFORM") {
            window.location.href = `${process.env.VUE_APP_APP
              }mob/goods/goodsList.do?platformCouponId=${cpId}&couPonStr=${couPonStr}`;
            return;
          }
          if (subBusId.split(",").length > 1) {
            window.location.href = `${process.env.VUE_APP_APP
              }mob/shop/shopDetail/${busId}?linkIds=${subBusId}&couPonStr=${couPonStr}`;
          } else {
            window.location.href = `${process.env.VUE_APP_APP}vm/goodDetails/${subBusId}`;
          }
        } else if (busType === "CATE") {
          window.location.href = `${process.env.VUE_APP_APP
            }mob/goods/goodsList.do?linkIds=${subBusId}&shopId=${busId}&couPonStr=${couPonStr}`;
        }
      },
      getCoupon(coupon) {
        // 回调路径
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        const params = {
          // boId: this.userInfo.id,
          regCode: coupon.regCode,
          busId: this.detail.fundShopId,
          regVal: coupon.regVal
        };
        this.$store
          .dispatch("goodDetails/goodDetails/getShopCoupon", this.$qs.stringify(params))
          .then(data => {
            if (data.msg) {
              Toast(data.msg);
              this.getLoadGoods();
            }
          });
      },
      // 视频播放
      goodInfoVideo() {
        $(".video-wrap").show();
        $("html,body").css({ overflow: "hidden" });
      },
      videoMask() {
        $(".video-wrap").hide();
        $("html,body").css({ overflow: "auto" });
        $(".video-wrap video")
          .get(0)
          .pause(); // 暂停控制
      },
      /**
       * 没有货品价格时判断用户是否登录
       * 已登录 -> 购买咨询页
       * 未登录 -> 登录页面 -> 回调货品详情页 -> 有货品价格（购买）/无货品价格（购买咨询页）
       */
      isToNotifyTheSeller(buyParams) {
        // const { goodsOrShopUrl } = buyParams;
        // 回调路径
        if (this.userInfo.id) {
          // 已登录 -> 跳转咨询页
          const url = encodeURIComponent(`/mob/shop/shopDetail/${buyParams.shopId}`);
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/isShowDisplayPrice.do?goodsId=${buyParams.goodsIdTo
            }&url=${url}`;
        }
      },
      toGoodsDetail(goodsId) {
        window.location.href = `/vm/goodDetails/${goodsId}`;
      },
      // num 输入的数字 scale精确小数位数 negative true负数
      formatNum(event) {
        let { value } = event.target;
        console.info(value);
        const scale = this.detail.goodsDigit;
        if (value && Number(value) < Number(this.detail.minOrderQuantity)) {
          Toast("不可少于最低起订量，请重新输入");
        }

        if (this.detail && this.detail.minOrderQuantity) {
          const minOrderQuantity = Number(this.detail.minOrderQuantity);
          if (value && Number(value) < minOrderQuantity && minOrderQuantity) {
            this.$nextTick(() => {
              this.addCartNum = minOrderQuantity;
            });
          }
        }

        value = value.replace(/[^\d.]/g, "");
        value = value.replace(/\.{2,}/g, ".");
        value = value.replace(".", "$#$");
        value = value.replace(/\./g, "");
        value = value.replace("$#$", ".");
        const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
        value = value.replace(reg, "$1$2.$3");
        value = parseFloat(value);
        this.addCartNum = value;
      },
      formatNum2(event, obj) {
        let { value } = event.target;
        console.info(value);
        const scale = obj.skuResList[0].goodsDigit;
        if (Number(value) && Number(value) < Number(obj.skuResList[0].minOrderQuantity)) {
          Toast("不可少于最低起订量，请重新输入");
        }
        if (value && Number(value) > Number(obj.skuResList[0].currNum)) {
          value = String(Number(obj.skuResList[0].currNum));
        }
        value = value.replace(/[^\d.]/g, "");
        value = value.replace(/\.{2,}/g, ".");
        value = value.replace(".", "$#$");
        value = value.replace(/\./g, "");
        value = value.replace("$#$", ".");
        const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
        value = value.replace(reg, "$1$2.$3");
        value = parseFloat(value);
        obj.quantity = value;
      },
      couponDialog() {
        if (
          this.detail.isVip === 1 ||
          (this.detail.isVip === 0 && this.detail.vipMoney) ||
          this.goodsCouponName
        ) {
          this.couponShow = true;
        }
      },
      saveVisitRecord(shareBoId) {
        const params = {
          shareBoId: shareBoId || "",
          url: encodeURIComponent(window.location.href)
        };
        this.$store
          .dispatch("goodDetails/goodDetails/saveVisitRecord", this.$qs.stringify(params))
          .then(data => {
            console.info(data);
          });
      },
      isGiftJump() {
        // 判断打开referer
        if (document.referrer && document.referrer.indexOf("mob/order/gift/get") !== -1) {
          this.isShowFoot = false;
        } else {
          this.isShowFoot = true;
        }
      },

      // 多规格值点击
      skuClick(sku, index) {
        // goodsId=220928132079002&skuSpecsIndex=green 200g
        const { goodsId } = this;
        this.specification.skuSpecsList[index] = sku;
        const skuSpecsIndex = this.specification.skuSpecsList.join(" ");
        Toast.loading({
          overlay: true,
          message: "加载中...",
          duration: 0,
          className: "sku-click-loading",
          overlayStyle: { "background-color": "#0000" }
        });
        this.$store
          .dispatch("goodDetails/goodDetails/getGoodsSkuId", {
            goodsId,
            skuSpecsIndex
          })
          .then(data => {
            console.info("多规格值点击", data);
            this.goodsId = data || goodsId;
            this.getGoodsDetail(this.$route.query, "skuClick");
            // const nameList = detail.name.split(" ");
            // this.detail.name = `${nameList[0]} ${skuSpecsIndex}`;
            // this.detail.skuSpecsIndex = skuSpecsIndex;
          });
      },

      videoFullScreen() {
        this.videoWXFirst = false;
        setTimeout(() => {
          const { draggableW, $refs } = this;
          const { videoPlayer } = $refs;
          const { width, height } = window.screen;
          if (draggableW == 80) {
            this.draggableX = 0;
            this.draggableY = 0;
            this.draggableW = width;
            this.draggableH = height - 29;
          } else {
            this.draggableW = 80;
            this.draggableH = 140;
            this.$nextTick(() => {
              this.draggableX = width - 100;
              this.draggableY = 170;
            });
          }
          if (videoPlayer.muted) {
            videoPlayer.muted = false;
          } else {
            videoPlayer.muted = true;
          }
          videoPlayer.play();
        }, 300);
      },

      draggableVisibleChange() {
        this.draggableVisible = false;
      },

      priceSplit2(price) {
        if (!price) {
          return ["", ""];
        }

        const arr = String(price).split("元");
        return arr[1] ? [arr[0], `${arr[1]}`] : [arr[0], ".00"];
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>
